var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/tokens/theme.ts
var ThemeTokens = /* @__PURE__ */ ((ThemeTokens2) => {
  ThemeTokens2["ColorBackgroundBody"] = "ColorBackgroundBody";
  ThemeTokens2["ColorBackgroundBase"] = "ColorBackgroundBase";
  ThemeTokens2["ColorBackgroundAlt"] = "ColorBackgroundAlt";
  ThemeTokens2["ColorBackgroundAlt2"] = "ColorBackgroundAlt2";
  ThemeTokens2["ColorBackgroundAlt3"] = "ColorBackgroundAlt3";
  ThemeTokens2["ColorBackgroundAccent"] = "ColorBackgroundAccent";
  ThemeTokens2["ColorBackgroundAccentAlt"] = "ColorBackgroundAccentAlt";
  ThemeTokens2["ColorBackgroundAccentAlt2"] = "ColorBackgroundAccentAlt2";
  ThemeTokens2["ColorBackgroundTooltip"] = "ColorBackgroundTooltip";
  ThemeTokens2["ColorTextBase"] = "ColorTextBase";
  ThemeTokens2["ColorTextAlt"] = "ColorTextAlt";
  ThemeTokens2["ColorTextAlt2"] = "ColorTextAlt2";
  ThemeTokens2["ColorTextDisabled"] = "ColorTextDisabled";
  ThemeTokens2["ColorTextError"] = "ColorTextError";
  ThemeTokens2["ColorTextWarn"] = "ColorTextWarn";
  ThemeTokens2["ColorTextSuccess"] = "ColorTextSuccess";
  ThemeTokens2["ColorTextInfo"] = "ColorTextInfo";
  ThemeTokens2["ColorTextAccent"] = "ColorTextAccent";
  ThemeTokens2["ColorTextInvert"] = "ColorTextInvert";
  ThemeTokens2["ColorTextLink"] = "ColorTextLink";
  ThemeTokens2["ColorTextLinkHover"] = "ColorTextLinkHover";
  ThemeTokens2["BorderDark"] = "BorderDark";
  ThemeTokens2["BorderMedium"] = "BorderMedium";
  ThemeTokens2["BorderLight"] = "BorderLight";
  ThemeTokens2["ColorBackgroundInfo"] = "ColorBackgroundInfo";
  ThemeTokens2["ColorBackgroundError"] = "ColorBackgroundError";
  ThemeTokens2["ColorBackgroundSuccess"] = "ColorBackgroundSuccess";
  ThemeTokens2["ColorBackgroundWarn"] = "ColorBackgroundWarn";
  ThemeTokens2["ColorBackgroundMisc"] = "ColorBackgroundMisc";
  ThemeTokens2["ColorBackgroundInactive"] = "ColorBackgroundInactive";
  ThemeTokens2["ColorBackgroundBrand"] = "ColorBackgroundBrand";
  ThemeTokens2["ColorBackgroundInvert"] = "ColorBackgroundInvert";
  ThemeTokens2["ColorIconBase"] = "ColorIconBase";
  ThemeTokens2["ColorIconAlt"] = "ColorIconAlt";
  ThemeTokens2["ColorIconAlt2"] = "ColorIconAlt2";
  ThemeTokens2["ColorIconDisabled"] = "ColorIconDisabled";
  ThemeTokens2["ColorIconError"] = "ColorIconError";
  ThemeTokens2["ColorIconWarn"] = "ColorIconWarn";
  ThemeTokens2["ColorIconSuccess"] = "ColorIconSuccess";
  ThemeTokens2["ColorIconInfo"] = "ColorIconInfo";
  ThemeTokens2["ColorIconAccent"] = "ColorIconAccent";
  ThemeTokens2["ColorIconLink"] = "ColorIconLink";
  ThemeTokens2["ColorIconLinkHover"] = "ColorIconLinkHover";
  ThemeTokens2["ColorIconInvert"] = "ColorIconInvert";
  ThemeTokens2["ColorLoaderLargeOuterBob"] = "ColorLoaderLargeOuterBob";
  ThemeTokens2["ColorLoaderLargeInnerBob"] = "ColorLoaderLargeInnerBob";
  ThemeTokens2["ColorLoaderMediumTopBob"] = "ColorLoaderMediumTopBob";
  ThemeTokens2["ColorLoaderMediumBackgroundBob"] = "ColorLoaderMediumBackgroundBob";
  ThemeTokens2["ColorEnrollmentLoaderOuterSpinner"] = "ColorEnrollmentLoaderOuterSpinner";
  ThemeTokens2["ColorEnrollmentLoaderInnerSpinner"] = "ColorEnrollmentLoaderInnerSpinner";
  ThemeTokens2["ColorButtonLoaderPrimary"] = "ColorButtonLoaderPrimary";
  ThemeTokens2["ColorButtonLoaderPrimaryBackground"] = "ColorButtonLoaderPrimaryBackground";
  ThemeTokens2["ColorButtonLoaderSecondary"] = "ColorButtonLoaderSecondary";
  ThemeTokens2["ColorButtonLoaderSecondaryBackground"] = "ColorButtonLoaderSecondaryBackground";
  return ThemeTokens2;
})(ThemeTokens || {});

// src/tokens/gradient.ts
var GradientTokens = /* @__PURE__ */ ((GradientTokens2) => {
  GradientTokens2["ColorPlayVsGradientExploreStart"] = "ColorPlayVsGradientExploreStart";
  GradientTokens2["ColorPlayVsGradientExploreEnd"] = "ColorPlayVsGradientExploreEnd";
  GradientTokens2["ColorPlayVsGradientMySchoolStart"] = "ColorPlayVsGradientMySchoolStart";
  GradientTokens2["ColorPlayVsGradientMySchoolEnd"] = "ColorPlayVsGradientMySchoolEnd";
  GradientTokens2["ColorPlayVsGradientManageStart"] = "ColorPlayVsGradientManageStart";
  GradientTokens2["ColorPlayVsGradientManageEnd"] = "ColorPlayVsGradientManageEnd";
  GradientTokens2["ColorPlayVsGradientScheduleStart"] = "ColorPlayVsGradientScheduleStart";
  GradientTokens2["ColorPlayVsGradientScheduleEnd"] = "ColorPlayVsGradientScheduleEnd";
  return GradientTokens2;
})(GradientTokens || {});

// src/tokens/overlay.ts
var OverlayTokens = /* @__PURE__ */ ((OverlayTokens2) => {
  OverlayTokens2["OverlayColorOpWhite1"] = "OverlayColorOpWhite1";
  OverlayTokens2["OverlayColorOpWhite3"] = "OverlayColorOpWhite3";
  OverlayTokens2["OverlayColorBackgroundAccent"] = "OverlayColorBackgroundAccent";
  OverlayTokens2["OverlayColorBackgroundAccentAlt"] = "OverlayColorBackgroundAccentAlt";
  OverlayTokens2["OverlayColorBackgroundAccentAlt2"] = "OverlayColorBackgroundAccentAlt2";
  OverlayTokens2["OverlayColorTextBase"] = "OverlayColorTextBase";
  OverlayTokens2["OverlayColorTextAlt"] = "OverlayColorTextAlt";
  OverlayTokens2["OverlayColorTextLink"] = "OverlayColorTextLink";
  OverlayTokens2["OverlayColorTextInvert"] = "OverlayColorTextInvert";
  OverlayTokens2["OverlayColorTextLinkHover"] = "OverlayColorTextLinkHover";
  OverlayTokens2["OverlayColorTextDisabled"] = "OverlayColorTextDisabled";
  OverlayTokens2["OverlayColorBackgroundAlt3"] = "OverlayColorBackgroundAlt3";
  OverlayTokens2["OverlayColorBackgroundInfo"] = "OverlayColorBackgroundInfo";
  OverlayTokens2["OverlayColorBackgroundError"] = "OverlayColorBackgroundError";
  OverlayTokens2["OverlayColorBackgroundSuccess"] = "OverlayColorBackgroundSuccess";
  OverlayTokens2["OverlayColorBackgroundWarn"] = "OverlayColorBackgroundWarn";
  OverlayTokens2["OverlayColorBackgroundMisc"] = "OverlayColorBackgroundMisc";
  OverlayTokens2["OverlayColorBackgroundInactive"] = "OverlayColorBackgroundInactive";
  OverlayTokens2["OverlayColorBackgroundBrand"] = "OverlayColorBackgroundBrand";
  OverlayTokens2["OverlayColorIconBase"] = "OverlayColorIconBase";
  OverlayTokens2["OverlayColorIconAlt"] = "OverlayColorIconAlt";
  OverlayTokens2["OverlayColorIconAlt2"] = "OverlayColorIconAlt2";
  OverlayTokens2["OverlayColorIconDisabled"] = "OverlayColorIconDisabled";
  OverlayTokens2["OverlayColorIconError"] = "OverlayColorIconError";
  OverlayTokens2["OverlayColorIconWarn"] = "OverlayColorIconWarn";
  OverlayTokens2["OverlayColorIconSuccess"] = "OverlayColorIconSuccess";
  OverlayTokens2["OverlayColorIconInfo"] = "OverlayColorIconInfo";
  OverlayTokens2["OverlayColorIconAccent"] = "ColorIconAccent";
  OverlayTokens2["OverlayColorIconLink"] = "OverlayColorIconLink";
  OverlayTokens2["OverlayColorIconLinkHover"] = "OverlayColorIconLinkHover";
  OverlayTokens2["OverlayColorIconInvert"] = "OverlayColorIconInvert";
  OverlayTokens2["OverlayBorderDark"] = "OverlayBorderDark";
  OverlayTokens2["OverlayBorderLight"] = "OverlayBorderLight";
  OverlayTokens2["OverlayBorderMedium"] = "OverlayBorderMedium";
  OverlayTokens2["OverlayColorOpBlack3"] = "OverlayColorOpBlack3";
  return OverlayTokens2;
})(OverlayTokens || {});

// src/tokens/esports/fifa.ts
var FifaTokens = /* @__PURE__ */ ((FifaTokens2) => {
  FifaTokens2["ColorEsportAccentFifa1"] = "ColorEsportAccentFifa1";
  FifaTokens2["ColorEsportAccentFifa2"] = "ColorEsportAccentFifa2";
  FifaTokens2["ColorEsportAccentFifa3"] = "ColorEsportAccentFifa3";
  FifaTokens2["ColorEsportAccentFifaBase"] = "ColorEsportAccentFifaBase";
  FifaTokens2["ColorEsportAccentFifa4"] = "ColorEsportAccentFifa4";
  FifaTokens2["ColorEsportAccentFifa5"] = "ColorEsportAccentFifa5";
  FifaTokens2["ColorEsportAccentFifa6"] = "ColorEsportAccentFifa6";
  FifaTokens2["ColorEsportAccentFifa7"] = "ColorEsportAccentFifa7";
  FifaTokens2["ColorEsportAccentFifa8"] = "ColorEsportAccentFifa8";
  FifaTokens2["ColorEsportGradientFifaStart"] = "ColorEsportGradientFifaStart";
  FifaTokens2["ColorEsportGradientFifaEnd"] = "ColorEsportGradientFifaEnd";
  return FifaTokens2;
})(FifaTokens || {});

// src/tokens/esports/fortnite.ts
var FortniteTokens = /* @__PURE__ */ ((FortniteTokens2) => {
  FortniteTokens2["ColorEsportAccentFn1"] = "ColorEsportAccentFn1";
  FortniteTokens2["ColorEsportAccentFn2"] = "ColorEsportAccentFn2";
  FortniteTokens2["ColorEsportAccentFn3"] = "ColorEsportAccentFn3";
  FortniteTokens2["ColorEsportAccentFnBase"] = "ColorEsportAccentFnBase";
  FortniteTokens2["ColorEsportAccentFn4"] = "ColorEsportAccentFn4";
  FortniteTokens2["ColorEsportAccentFn5"] = "ColorEsportAccentFn5";
  FortniteTokens2["ColorEsportAccentFn6"] = "ColorEsportAccentFn6";
  FortniteTokens2["ColorEsportAccentFn7"] = "ColorEsportAccentFn7";
  FortniteTokens2["ColorEsportAccentFn8"] = "ColorEsportAccentFn8";
  FortniteTokens2["ColorEsportGradientFnStart"] = "ColorEsportGradientFnStart";
  FortniteTokens2["ColorEsportGradientFnEnd"] = "ColorEsportGradientFnEnd";
  return FortniteTokens2;
})(FortniteTokens || {});

// src/tokens/esports/hearthstone.ts
var HearthStoneTokens = /* @__PURE__ */ ((HearthStoneTokens2) => {
  HearthStoneTokens2["ColorEsportAccentHS1"] = "ColorEsportAccentHS1";
  HearthStoneTokens2["ColorEsportAccentHS2"] = "ColorEsportAccentHS2";
  HearthStoneTokens2["ColorEsportAccentHS3"] = "ColorEsportAccentHS3";
  HearthStoneTokens2["ColorEsportAccentHSBase"] = "ColorEsportAccentHSBase";
  HearthStoneTokens2["ColorEsportAccentHS4"] = "ColorEsportAccentHS4";
  HearthStoneTokens2["ColorEsportAccentHS5"] = "ColorEsportAccentHS5";
  HearthStoneTokens2["ColorEsportAccentHS6"] = "ColorEsportAccentHS6";
  HearthStoneTokens2["ColorEsportAccentHS7"] = "ColorEsportAccentHS7";
  HearthStoneTokens2["ColorEsportAccentHS8"] = "ColorEsportAccentHS8";
  HearthStoneTokens2["ColorEsportGradientHSStart"] = "ColorEsportGradientHSStart";
  HearthStoneTokens2["ColorEsportGradientHSEnd"] = "ColorEsportGradientHSEnd";
  return HearthStoneTokens2;
})(HearthStoneTokens || {});

// src/tokens/esports/leagueOfLegends.ts
var LeagueOfLegendsTokens = /* @__PURE__ */ ((LeagueOfLegendsTokens2) => {
  LeagueOfLegendsTokens2["ColorEsportAccentLoL1"] = "ColorEsportAccentLoL1";
  LeagueOfLegendsTokens2["ColorEsportAccentLoL2"] = "ColorEsportAccentLoL2";
  LeagueOfLegendsTokens2["ColorEsportAccentLoL3"] = "ColorEsportAccentLoL3";
  LeagueOfLegendsTokens2["ColorEsportAccentLoLBase"] = "ColorEsportAccentLoLBase";
  LeagueOfLegendsTokens2["ColorEsportAccentLoL4"] = "ColorEsportAccentLoL4";
  LeagueOfLegendsTokens2["ColorEsportAccentLoL5"] = "ColorEsportAccentLoL5";
  LeagueOfLegendsTokens2["ColorEsportAccentLoL6"] = "ColorEsportAccentLoL6";
  LeagueOfLegendsTokens2["ColorEsportAccentLoL7"] = "ColorEsportAccentLoL7";
  LeagueOfLegendsTokens2["ColorEsportAccentLoL8"] = "ColorEsportAccentLoL8";
  LeagueOfLegendsTokens2["ColorEsportGradientLoLStart"] = "ColorEsportGradientLoLStart";
  LeagueOfLegendsTokens2["ColorEsportGradientLoLEnd"] = "ColorEsportGradientLoLEnd";
  return LeagueOfLegendsTokens2;
})(LeagueOfLegendsTokens || {});

// src/tokens/esports/madden.ts
var MaddenTokens = /* @__PURE__ */ ((MaddenTokens2) => {
  MaddenTokens2["ColorEsportAccentMadden1"] = "ColorEsportAccentMadden1";
  MaddenTokens2["ColorEsportAccentMadden2"] = "ColorEsportAccentMadden2";
  MaddenTokens2["ColorEsportAccentMadden3"] = "ColorEsportAccentMadden3";
  MaddenTokens2["ColorEsportAccentMaddenBase"] = "ColorEsportAccentMaddenBase";
  MaddenTokens2["ColorEsportAccentMadden4"] = "ColorEsportAccentMadden4";
  MaddenTokens2["ColorEsportAccentMadden5"] = "ColorEsportAccentMadden5";
  MaddenTokens2["ColorEsportAccentMadden6"] = "ColorEsportAccentMadden6";
  MaddenTokens2["ColorEsportAccentMadden7"] = "ColorEsportAccentMadden7";
  MaddenTokens2["ColorEsportAccentMadden8"] = "ColorEsportAccentMadden8";
  MaddenTokens2["ColorEsportGradientMaddenStart"] = "ColorEsportGradientMaddenStart";
  MaddenTokens2["ColorEsportGradientMaddenEnd"] = "ColorEsportGradientMaddenEnd";
  return MaddenTokens2;
})(MaddenTokens || {});

// src/tokens/esports/marioKart.ts
var MarioKartTokens = /* @__PURE__ */ ((MarioKartTokens2) => {
  MarioKartTokens2["ColorEsportAccentMk1"] = "ColorEsportAccentMk1";
  MarioKartTokens2["ColorEsportAccentMk2"] = "ColorEsportAccentMk2";
  MarioKartTokens2["ColorEsportAccentMk3"] = "ColorEsportAccentMk3";
  MarioKartTokens2["ColorEsportAccentMkBase"] = "ColorEsportAccentMkBase";
  MarioKartTokens2["ColorEsportAccentMk4"] = "ColorEsportAccentMk4";
  MarioKartTokens2["ColorEsportAccentMk5"] = "ColorEsportAccentMk5";
  MarioKartTokens2["ColorEsportAccentMk6"] = "ColorEsportAccentMk6";
  MarioKartTokens2["ColorEsportAccentMk7"] = "ColorEsportAccentMk7";
  MarioKartTokens2["ColorEsportAccentMk8"] = "ColorEsportAccentMk8";
  MarioKartTokens2["ColorEsportGradientMkStart"] = "ColorEsportGradientMkStart";
  MarioKartTokens2["ColorEsportGradientMkEnd"] = "ColorEsportGradientMkEnd";
  return MarioKartTokens2;
})(MarioKartTokens || {});

// src/tokens/esports/nba2k.ts
var Nba2kTokens = /* @__PURE__ */ ((Nba2kTokens2) => {
  Nba2kTokens2["ColorEsportAccentNBA1"] = "ColorEsportAccentNBA1";
  Nba2kTokens2["ColorEsportAccentNBA2"] = "ColorEsportAccentNBA2";
  Nba2kTokens2["ColorEsportAccentNBA3"] = "ColorEsportAccentNBA3";
  Nba2kTokens2["ColorEsportAccentNBABase"] = "ColorEsportAccentNBABase";
  Nba2kTokens2["ColorEsportAccentNBA4"] = "ColorEsportAccentNBA4";
  Nba2kTokens2["ColorEsportAccentNBA5"] = "ColorEsportAccentNBA5";
  Nba2kTokens2["ColorEsportAccentNBA6"] = "ColorEsportAccentNBA6";
  Nba2kTokens2["ColorEsportAccentNBA7"] = "ColorEsportAccentNBA7";
  Nba2kTokens2["ColorEsportAccentNBA8"] = "ColorEsportAccentNBA8";
  Nba2kTokens2["ColorEsportGradientNBAStart"] = "ColorEsportGradientNBAStart";
  Nba2kTokens2["ColorEsportGradientNBAEnd"] = "ColorEsportGradientNBAEnd";
  return Nba2kTokens2;
})(Nba2kTokens || {});

// src/tokens/esports/overwatch.ts
var OverwatchTokens = /* @__PURE__ */ ((OverwatchTokens2) => {
  OverwatchTokens2["ColorEsportAccentOW1"] = "ColorEsportAccentOW1";
  OverwatchTokens2["ColorEsportAccentOW2"] = "ColorEsportAccentOW2";
  OverwatchTokens2["ColorEsportAccentOW3"] = "ColorEsportAccentOW3";
  OverwatchTokens2["ColorEsportAccentOWBase"] = "ColorEsportAccentOWBase";
  OverwatchTokens2["ColorEsportAccentOW4"] = "ColorEsportAccentOW4";
  OverwatchTokens2["ColorEsportAccentOW5"] = "ColorEsportAccentOW5";
  OverwatchTokens2["ColorEsportAccentOW6"] = "ColorEsportAccentOW6";
  OverwatchTokens2["ColorEsportAccentOW7"] = "ColorEsportAccentOW7";
  OverwatchTokens2["ColorEsportAccentOW8"] = "ColorEsportAccentOW8";
  OverwatchTokens2["ColorEsportGradientOWStart"] = "ColorEsportGradientOWStart";
  OverwatchTokens2["ColorEsportGradientOWEnd"] = "ColorEsportGradientOWEnd";
  return OverwatchTokens2;
})(OverwatchTokens || {});

// src/tokens/esports/rocketLeague.ts
var RocketLeagueTokens = /* @__PURE__ */ ((RocketLeagueTokens2) => {
  RocketLeagueTokens2["ColorEsportAccentRL1"] = "ColorEsportAccentRL1";
  RocketLeagueTokens2["ColorEsportAccentRL2"] = "ColorEsportAccentRL2";
  RocketLeagueTokens2["ColorEsportAccentRL3"] = "ColorEsportAccentRL3";
  RocketLeagueTokens2["ColorEsportAccentRLBase"] = "ColorEsportAccentRLBase";
  RocketLeagueTokens2["ColorEsportAccentRL4"] = "ColorEsportAccentRL4";
  RocketLeagueTokens2["ColorEsportAccentRL5"] = "ColorEsportAccentRL5";
  RocketLeagueTokens2["ColorEsportAccentRL6"] = "ColorEsportAccentRL6";
  RocketLeagueTokens2["ColorEsportAccentRL7"] = "ColorEsportAccentRL7";
  RocketLeagueTokens2["ColorEsportAccentRL8"] = "ColorEsportAccentRL8";
  RocketLeagueTokens2["ColorEsportGradientRLStart"] = "ColorEsportGradientRLStart";
  RocketLeagueTokens2["ColorEsportGradientRLEnd"] = "ColorEsportGradientRLEnd";
  return RocketLeagueTokens2;
})(RocketLeagueTokens || {});

// src/tokens/esports/smashBros.ts
var SmashBrosTokens = /* @__PURE__ */ ((SmashBrosTokens2) => {
  SmashBrosTokens2["ColorEsportAccentSU1"] = "ColorEsportAccentSU1";
  SmashBrosTokens2["ColorEsportAccentSU2"] = "ColorEsportAccentSU2";
  SmashBrosTokens2["ColorEsportAccentSU3"] = "ColorEsportAccentSU3";
  SmashBrosTokens2["ColorEsportAccentSUBase"] = "ColorEsportAccentSUBase";
  SmashBrosTokens2["ColorEsportAccentSU4"] = "ColorEsportAccentSU4";
  SmashBrosTokens2["ColorEsportAccentSU5"] = "ColorEsportAccentSU5";
  SmashBrosTokens2["ColorEsportAccentSU6"] = "ColorEsportAccentSU6";
  SmashBrosTokens2["ColorEsportAccentSU7"] = "ColorEsportAccentSU7";
  SmashBrosTokens2["ColorEsportAccentSU8"] = "ColorEsportAccentSU8";
  SmashBrosTokens2["ColorEsportGradientSUStart"] = "ColorEsportGradientSUStart";
  SmashBrosTokens2["ColorEsportGradientSUEnd"] = "ColorEsportGradientSUEnd";
  return SmashBrosTokens2;
})(SmashBrosTokens || {});

// src/tokens/esports/smite.ts
var SmiteTokens = /* @__PURE__ */ ((SmiteTokens2) => {
  SmiteTokens2["ColorEsportAccentSmite1"] = "ColorEsportAccentSmite1";
  SmiteTokens2["ColorEsportAccentSmite2"] = "ColorEsportAccentSmite2";
  SmiteTokens2["ColorEsportAccentSmite3"] = "ColorEsportAccentSmite3";
  SmiteTokens2["ColorEsportAccentSmiteBase"] = "ColorEsportAccentSmiteBase";
  SmiteTokens2["ColorEsportAccentSmite4"] = "ColorEsportAccentSmite4";
  SmiteTokens2["ColorEsportAccentSmite5"] = "ColorEsportAccentSmite5";
  SmiteTokens2["ColorEsportAccentSmite6"] = "ColorEsportAccentSmite6";
  SmiteTokens2["ColorEsportAccentSmite7"] = "ColorEsportAccentSmite7";
  SmiteTokens2["ColorEsportAccentSmite8"] = "ColorEsportAccentSmite8";
  SmiteTokens2["ColorEsportGradientSmiteStart"] = "ColorEsportGradientSmiteStart";
  SmiteTokens2["ColorEsportGradientSmiteEnd"] = "ColorEsportGradientSmiteEnd";
  return SmiteTokens2;
})(SmiteTokens || {});

// src/tokens/esports/splatoon.ts
var SplatoonTokens = /* @__PURE__ */ ((SplatoonTokens2) => {
  SplatoonTokens2["ColorEsportAccentSplatoonBase"] = "ColorEsportAccentSplatoonBase";
  SplatoonTokens2["ColorEsportAccentSplatoon1"] = "ColorEsportAccentSplatoon1";
  SplatoonTokens2["ColorEsportAccentSplatoon2"] = "ColorEsportAccentSplatoon2";
  SplatoonTokens2["ColorEsportAccentSplatoon3"] = "ColorEsportAccentSplatoon3";
  SplatoonTokens2["ColorEsportAccentSplatoon4"] = "ColorEsportAccentSplatoon4";
  SplatoonTokens2["ColorEsportAccentSplatoon5"] = "ColorEsportAccentSplatoon5";
  SplatoonTokens2["ColorEsportAccentSplatoon6"] = "ColorEsportAccentSplatoon6";
  SplatoonTokens2["ColorEsportAccentSplatoon7"] = "ColorEsportAccentSplatoon7";
  SplatoonTokens2["ColorEsportAccentSplatoon8"] = "ColorEsportAccentSplatoon8";
  SplatoonTokens2["ColorEsportGradientSplatoonStart"] = "ColorEsportGradientSplatoonStart";
  SplatoonTokens2["ColorEsportGradientSplatoonEnd"] = "ColorEsportGradientSplatoonEnd";
  return SplatoonTokens2;
})(SplatoonTokens || {});

// src/tokens/esports/valorant.ts
var ValorantTokens = /* @__PURE__ */ ((ValorantTokens2) => {
  ValorantTokens2["ColorEsportAccentVlr1"] = "ColorEsportAccentVlr1";
  ValorantTokens2["ColorEsportAccentVlr2"] = "ColorEsportAccentVlr2";
  ValorantTokens2["ColorEsportAccentVlr3"] = "ColorEsportAccentVlr3";
  ValorantTokens2["ColorEsportAccentVlrBase"] = "ColorEsportAccentVlrBase";
  ValorantTokens2["ColorEsportAccentVlr4"] = "ColorEsportAccentVlr4";
  ValorantTokens2["ColorEsportAccentVlr5"] = "ColorEsportAccentVlr5";
  ValorantTokens2["ColorEsportAccentVlr6"] = "ColorEsportAccentVlr6";
  ValorantTokens2["ColorEsportAccentVlr7"] = "ColorEsportAccentVlr7";
  ValorantTokens2["ColorEsportAccentVlr8"] = "ColorEsportAccentVlr8";
  ValorantTokens2["ColorEsportGradientVlrStart"] = "ColorEsportGradientVlrStart";
  ValorantTokens2["ColorEsportGradientVlrEnd"] = "ColorEsportGradientVlrEnd";
  return ValorantTokens2;
})(ValorantTokens || {});

// src/tokens/esports/chess.ts
var ChessTokens = /* @__PURE__ */ ((ChessTokens2) => {
  ChessTokens2["ColorEsportAccentChess1"] = "ColorEsportAccentChess1";
  ChessTokens2["ColorEsportAccentChess2"] = "ColorEsportAccentChess2";
  ChessTokens2["ColorEsportAccentChess3"] = "ColorEsportAccentChess3";
  ChessTokens2["ColorEsportAccentChessBase"] = "ColorEsportAccentChessBase";
  ChessTokens2["ColorEsportAccentChess4"] = "ColorEsportAccentChess4";
  ChessTokens2["ColorEsportAccentChess5"] = "ColorEsportAccentChess5";
  ChessTokens2["ColorEsportAccentChess6"] = "ColorEsportAccentChess6";
  ChessTokens2["ColorEsportAccentChess7"] = "ColorEsportAccentChess7";
  ChessTokens2["ColorEsportAccentChess8"] = "ColorEsportAccentChess8";
  ChessTokens2["ColorEsportGradientChessStart"] = "ColorEsportGradientChessStart";
  ChessTokens2["ColorEsportGradientChessEnd"] = "ColorEsportGradientChessEnd";
  return ChessTokens2;
})(ChessTokens || {});

// src/tokens/esports/fc.ts
var FCTokens = /* @__PURE__ */ ((FCTokens2) => {
  FCTokens2["ColorEsportAccentFC1"] = "ColorEsportAccentFC1";
  FCTokens2["ColorEsportAccentFC2"] = "ColorEsportAccentFC2";
  FCTokens2["ColorEsportAccentFC3"] = "ColorEsportAccentFC3";
  FCTokens2["ColorEsportAccentFCBase"] = "ColorEsportAccentFCBase";
  FCTokens2["ColorEsportAccentFC4"] = "ColorEsportAccentFC4";
  FCTokens2["ColorEsportAccentFC5"] = "ColorEsportAccentFC5";
  FCTokens2["ColorEsportAccentFC6"] = "ColorEsportAccentFC6";
  FCTokens2["ColorEsportAccentFC7"] = "ColorEsportAccentFC7";
  FCTokens2["ColorEsportAccentFC8"] = "ColorEsportAccentFC8";
  FCTokens2["ColorEsportGradientFCStart"] = "ColorEsportGradientFCStart";
  FCTokens2["ColorEsportGradientFCEnd"] = "ColorEsportGradientFCEnd";
  return FCTokens2;
})(FCTokens || {});

// src/tokens/esports/formula1.ts
var F1Tokens = /* @__PURE__ */ ((F1Tokens2) => {
  F1Tokens2["ColorEsportAccentF11"] = "ColorEsportAccentF11";
  F1Tokens2["ColorEsportAccentF12"] = "ColorEsportAccentF12";
  F1Tokens2["ColorEsportAccentF13"] = "ColorEsportAccentF13";
  F1Tokens2["ColorEsportAccentF1Base"] = "ColorEsportAccentF1Base";
  F1Tokens2["ColorEsportAccentF14"] = "ColorEsportAccentF14";
  F1Tokens2["ColorEsportAccentF15"] = "ColorEsportAccentF15";
  F1Tokens2["ColorEsportAccentF16"] = "ColorEsportAccentF16";
  F1Tokens2["ColorEsportAccentF17"] = "ColorEsportAccentF17";
  F1Tokens2["ColorEsportAccentF18"] = "ColorEsportAccentF18";
  F1Tokens2["ColorEsportGradientF1Start"] = "ColorEsportGradientF1Start";
  F1Tokens2["ColorEsportGradientF1End"] = "ColorEsportGradientF1End";
  return F1Tokens2;
})(F1Tokens || {});

// src/tokens/esports/minecraft.ts
var MCTokens = /* @__PURE__ */ ((MCTokens2) => {
  MCTokens2["ColorEsportAccentMC1"] = "ColorEsportAccentMC1";
  MCTokens2["ColorEsportAccentMC2"] = "ColorEsportAccentMC2";
  MCTokens2["ColorEsportAccentMC3"] = "ColorEsportAccentMC3";
  MCTokens2["ColorEsportAccentMCBase"] = "ColorEsportAccentMCBase";
  MCTokens2["ColorEsportAccentMC4"] = "ColorEsportAccentMC4";
  MCTokens2["ColorEsportAccentMC5"] = "ColorEsportAccentMC5";
  MCTokens2["ColorEsportAccentMC6"] = "ColorEsportAccentMC6";
  MCTokens2["ColorEsportAccentMC7"] = "ColorEsportAccentMC7";
  MCTokens2["ColorEsportAccentMC8"] = "ColorEsportAccentMC8";
  MCTokens2["ColorEsportGradientMCStart"] = "ColorEsportGradientMCStart";
  MCTokens2["ColorEsportGradientMCEnd"] = "ColorEsportGradientMCEnd";
  return MCTokens2;
})(MCTokens || {});

// src/tokens/esports/pokemonUnite.ts
var PUTokens = /* @__PURE__ */ ((PUTokens2) => {
  PUTokens2["ColorEsportAccentPU1"] = "ColorEsportAccentPU1";
  PUTokens2["ColorEsportAccentPU2"] = "ColorEsportAccentPU2";
  PUTokens2["ColorEsportAccentPU3"] = "ColorEsportAccentPU3";
  PUTokens2["ColorEsportAccentPUBase"] = "ColorEsportAccentPUBase";
  PUTokens2["ColorEsportAccentPU4"] = "ColorEsportAccentPU4";
  PUTokens2["ColorEsportAccentPU5"] = "ColorEsportAccentPU5";
  PUTokens2["ColorEsportAccentPU6"] = "ColorEsportAccentPU6";
  PUTokens2["ColorEsportAccentPU7"] = "ColorEsportAccentPU7";
  PUTokens2["ColorEsportAccentPU8"] = "ColorEsportAccentPU8";
  PUTokens2["ColorEsportGradientPUStart"] = "ColorEsportGradientPUStart";
  PUTokens2["ColorEsportGradientPUEnd"] = "ColorEsportGradientPUEnd";
  return PUTokens2;
})(PUTokens || {});

// src/tokens/esports/streetFighter6.ts
var SF6Tokens = /* @__PURE__ */ ((SF6Tokens2) => {
  SF6Tokens2["ColorEsportAccentSF61"] = "ColorEsportAccentSF61";
  SF6Tokens2["ColorEsportAccentSF62"] = "ColorEsportAccentSF62";
  SF6Tokens2["ColorEsportAccentSF63"] = "ColorEsportAccentSF63";
  SF6Tokens2["ColorEsportAccentSF6Base"] = "ColorEsportAccentSF6Base";
  SF6Tokens2["ColorEsportAccentSF64"] = "ColorEsportAccentSF64";
  SF6Tokens2["ColorEsportAccentSF65"] = "ColorEsportAccentSF65";
  SF6Tokens2["ColorEsportAccentSF66"] = "ColorEsportAccentSF66";
  SF6Tokens2["ColorEsportAccentSF67"] = "ColorEsportAccentSF67";
  SF6Tokens2["ColorEsportAccentSF68"] = "ColorEsportAccentSF68";
  SF6Tokens2["ColorEsportGradientSF6Start"] = "ColorEsportGradientSF6Start";
  SF6Tokens2["ColorEsportGradientSF6End"] = "ColorEsportGradientSF6End";
  return SF6Tokens2;
})(SF6Tokens || {});

// src/tokens/esports/aram.ts
var ARAMTokens = /* @__PURE__ */ ((ARAMTokens2) => {
  ARAMTokens2["ColorEsportAccentARAM1"] = "ColorEsportAccentARAM1";
  ARAMTokens2["ColorEsportAccentARAM2"] = "ColorEsportAccentARAM2";
  ARAMTokens2["ColorEsportAccentARAM3"] = "ColorEsportAccentARAM3";
  ARAMTokens2["ColorEsportAccentARAMBase"] = "ColorEsportAccentARAMBase";
  ARAMTokens2["ColorEsportAccentARAM4"] = "ColorEsportAccentARAM4";
  ARAMTokens2["ColorEsportAccentARAM5"] = "ColorEsportAccentARAM5";
  ARAMTokens2["ColorEsportAccentARAM6"] = "ColorEsportAccentARAM6";
  ARAMTokens2["ColorEsportAccentARAM7"] = "ColorEsportAccentARAM7";
  ARAMTokens2["ColorEsportAccentARAM8"] = "ColorEsportAccentARAM8";
  ARAMTokens2["ColorEsportGradientARAMStart"] = "ColorEsportGradientARAMStart";
  ARAMTokens2["ColorEsportGradientARAMEnd"] = "ColorEsportGradientARAMEnd";
  return ARAMTokens2;
})(ARAMTokens || {});

// src/tokens/esports/collegeFootball25.ts
var CFB25Tokens = /* @__PURE__ */ ((CFB25Tokens2) => {
  CFB25Tokens2["ColorEsportAccentCFB251"] = "ColorEsportAccentCFB251";
  CFB25Tokens2["ColorEsportAccentCFB252"] = "ColorEsportAccentCFB252";
  CFB25Tokens2["ColorEsportAccentCFB253"] = "ColorEsportAccentCFB253";
  CFB25Tokens2["ColorEsportAccentCFB25Base"] = "ColorEsportAccentCFB25Base";
  CFB25Tokens2["ColorEsportAccentCFB254"] = "ColorEsportAccentCFB254";
  CFB25Tokens2["ColorEsportAccentCFB255"] = "ColorEsportAccentCFB255";
  CFB25Tokens2["ColorEsportAccentCFB256"] = "ColorEsportAccentCFB256";
  CFB25Tokens2["ColorEsportAccentCFB257"] = "ColorEsportAccentCFB257";
  CFB25Tokens2["ColorEsportAccentCFB258"] = "ColorEsportAccentCFB258";
  CFB25Tokens2["ColorEsportGradientCFB25Start"] = "ColorEsportGradientCFB25Start";
  CFB25Tokens2["ColorEsportGradientCFB25End"] = "ColorEsportGradientCFB25End";
  return CFB25Tokens2;
})(CFB25Tokens || {});

// src/tokens/esports.ts
var EsportsTokens = __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, FifaTokens), FortniteTokens), HearthStoneTokens), LeagueOfLegendsTokens), MaddenTokens), MarioKartTokens), Nba2kTokens), OverwatchTokens), RocketLeagueTokens), SmashBrosTokens), SmiteTokens), SplatoonTokens), ValorantTokens), ChessTokens), FCTokens), F1Tokens), MCTokens), PUTokens), SF6Tokens), ARAMTokens), CFB25Tokens);

// src/palettes/dark.ts
import { colors } from "@playvs-inc/nexus-core";
var DarkPalette = {
  ["ColorBackgroundBody" /* ColorBackgroundBody */]: colors.Grey[15],
  ["ColorBackgroundBase" /* ColorBackgroundBase */]: colors.Grey[14],
  ["ColorBackgroundAlt" /* ColorBackgroundAlt */]: colors.Grey[12],
  ["ColorBackgroundAlt2" /* ColorBackgroundAlt2 */]: colors.Grey[10],
  ["ColorBackgroundAlt3" /* ColorBackgroundAlt3 */]: colors.OpWhite[13],
  ["ColorBackgroundAccent" /* ColorBackgroundAccent */]: colors.PvsOrange[8],
  ["ColorBackgroundAccentAlt" /* ColorBackgroundAccentAlt */]: colors.PvsOrange[9],
  ["ColorBackgroundAccentAlt2" /* ColorBackgroundAccentAlt2 */]: colors.PvsOrange[10],
  ["ColorBackgroundTooltip" /* ColorBackgroundTooltip */]: colors.Grey[12],
  ["ColorTextBase" /* ColorTextBase */]: colors.Grey[1],
  ["ColorTextAlt" /* ColorTextAlt */]: colors.Grey[4],
  ["ColorTextAlt2" /* ColorTextAlt2 */]: colors.Grey[7],
  ["ColorTextDisabled" /* ColorTextDisabled */]: colors.Grey[8],
  ["ColorTextError" /* ColorTextError */]: colors.RedError[4],
  ["ColorTextWarn" /* ColorTextWarn */]: colors.YellowWarn[4],
  ["ColorTextSuccess" /* ColorTextSuccess */]: colors.GreenSuccess[3],
  ["ColorTextInfo" /* ColorTextInfo */]: colors.BlueInfo[3],
  ["ColorTextAccent" /* ColorTextAccent */]: colors.AccentRaven[4],
  ["ColorTextInvert" /* ColorTextInvert */]: colors.Grey[14],
  ["ColorTextLink" /* ColorTextLink */]: colors.PvsOrange[8],
  ["ColorTextLinkHover" /* ColorTextLinkHover */]: colors.PvsOrange[7],
  ["BorderDark" /* BorderDark */]: colors.OpWhite[3],
  ["BorderMedium" /* BorderMedium */]: colors.OpWhite[10],
  ["BorderLight" /* BorderLight */]: colors.OpWhite[13],
  ["ColorBackgroundInfo" /* ColorBackgroundInfo */]: `${colors.BlueInfo[6]}59`,
  ["ColorBackgroundError" /* ColorBackgroundError */]: `${colors.RedError[6]}59`,
  ["ColorBackgroundSuccess" /* ColorBackgroundSuccess */]: `${colors.GreenSuccess[6]}59`,
  ["ColorBackgroundWarn" /* ColorBackgroundWarn */]: `${colors.YellowWarn[6]}59`,
  ["ColorBackgroundMisc" /* ColorBackgroundMisc */]: `${colors.AccentRaven[6]}59`,
  ["ColorBackgroundInactive" /* ColorBackgroundInactive */]: colors.OpWhite[14],
  ["ColorBackgroundBrand" /* ColorBackgroundBrand */]: `${colors.PvsOrange[9]}4D`,
  ["ColorBackgroundInvert" /* ColorBackgroundInvert */]: colors.OpWhite[3],
  ["ColorIconBase" /* ColorIconBase */]: colors.Grey[1],
  ["ColorIconAlt" /* ColorIconAlt */]: colors.Grey[4],
  ["ColorIconAlt2" /* ColorIconAlt2 */]: colors.Grey[7],
  ["ColorIconDisabled" /* ColorIconDisabled */]: colors.Grey[9],
  ["ColorIconError" /* ColorIconError */]: colors.RedError[4],
  ["ColorIconWarn" /* ColorIconWarn */]: colors.YellowWarn[4],
  ["ColorIconSuccess" /* ColorIconSuccess */]: colors.GreenSuccess[3],
  ["ColorIconInfo" /* ColorIconInfo */]: colors.BlueInfo[3],
  ["ColorIconAccent" /* ColorIconAccent */]: colors.AccentRaven[4],
  ["ColorIconLink" /* ColorIconLink */]: colors.PvsOrange[8],
  ["ColorIconLinkHover" /* ColorIconLinkHover */]: colors.PvsOrange[7],
  ["ColorIconInvert" /* ColorIconInvert */]: colors.Grey[14],
  ["ColorLoaderLargeOuterBob" /* ColorLoaderLargeOuterBob */]: colors.Grey[9],
  ["ColorLoaderLargeInnerBob" /* ColorLoaderLargeInnerBob */]: colors.Grey[11],
  ["ColorLoaderMediumTopBob" /* ColorLoaderMediumTopBob */]: colors.Grey[9],
  ["ColorLoaderMediumBackgroundBob" /* ColorLoaderMediumBackgroundBob */]: colors.Grey[11],
  ["ColorEnrollmentLoaderOuterSpinner" /* ColorEnrollmentLoaderOuterSpinner */]: colors.Grey[9],
  ["ColorEnrollmentLoaderInnerSpinner" /* ColorEnrollmentLoaderInnerSpinner */]: colors.Grey[11],
  ["ColorButtonLoaderPrimary" /* ColorButtonLoaderPrimary */]: colors.PvsOrange[4],
  ["ColorButtonLoaderPrimaryBackground" /* ColorButtonLoaderPrimaryBackground */]: colors.PvsOrange[7],
  ["ColorButtonLoaderSecondary" /* ColorButtonLoaderSecondary */]: colors.Grey[2],
  ["ColorButtonLoaderSecondaryBackground" /* ColorButtonLoaderSecondaryBackground */]: colors.Grey[8]
};

// src/palettes/light.ts
import { colors as colors2 } from "@playvs-inc/nexus-core";
var LightPalette = {
  ["ColorBackgroundBody" /* ColorBackgroundBody */]: colors2.Grey[1],
  ["ColorBackgroundBase" /* ColorBackgroundBase */]: colors2.White,
  ["ColorBackgroundAlt" /* ColorBackgroundAlt */]: colors2.Grey[2],
  ["ColorBackgroundAlt2" /* ColorBackgroundAlt2 */]: colors2.Grey[4],
  ["ColorBackgroundAlt3" /* ColorBackgroundAlt3 */]: colors2.OpBlack[14],
  ["ColorBackgroundAccent" /* ColorBackgroundAccent */]: colors2.PvsOrange[8],
  ["ColorBackgroundAccentAlt" /* ColorBackgroundAccentAlt */]: colors2.PvsOrange[9],
  ["ColorBackgroundAccentAlt2" /* ColorBackgroundAccentAlt2 */]: colors2.PvsOrange[10],
  ["ColorBackgroundInvert" /* ColorBackgroundInvert */]: colors2.OpBlack[3],
  ["ColorBackgroundInfo" /* ColorBackgroundInfo */]: colors2.BlueInfo[2],
  ["ColorBackgroundError" /* ColorBackgroundError */]: colors2.RedError[2],
  ["ColorBackgroundSuccess" /* ColorBackgroundSuccess */]: colors2.GreenSuccess[2],
  ["ColorBackgroundWarn" /* ColorBackgroundWarn */]: colors2.YellowWarn[2],
  ["ColorBackgroundMisc" /* ColorBackgroundMisc */]: colors2.AccentRaven[2],
  ["ColorBackgroundInactive" /* ColorBackgroundInactive */]: colors2.Grey[5],
  ["ColorBackgroundBrand" /* ColorBackgroundBrand */]: colors2.PvsOrange[3],
  ["ColorBackgroundTooltip" /* ColorBackgroundTooltip */]: colors2.Grey[12],
  ["ColorTextBase" /* ColorTextBase */]: colors2.Grey[14],
  ["ColorTextAlt" /* ColorTextAlt */]: colors2.Grey[10],
  ["ColorTextAlt2" /* ColorTextAlt2 */]: colors2.Grey[9],
  ["ColorTextDisabled" /* ColorTextDisabled */]: colors2.Grey[8],
  ["ColorTextError" /* ColorTextError */]: colors2.RedError[5],
  ["ColorTextWarn" /* ColorTextWarn */]: colors2.YellowWarn[6],
  ["ColorTextSuccess" /* ColorTextSuccess */]: colors2.GreenSuccess[5],
  ["ColorTextInfo" /* ColorTextInfo */]: colors2.BlueInfo[4],
  ["ColorTextAccent" /* ColorTextAccent */]: colors2.AccentRaven[6],
  ["ColorTextInvert" /* ColorTextInvert */]: colors2.Grey[1],
  ["ColorTextLink" /* ColorTextLink */]: colors2.PvsOrange[9],
  ["ColorTextLinkHover" /* ColorTextLinkHover */]: colors2.PvsOrange[12],
  ["BorderDark" /* BorderDark */]: colors2.OpBlack[3],
  ["BorderMedium" /* BorderMedium */]: colors2.OpBlack[10],
  ["BorderLight" /* BorderLight */]: colors2.OpBlack[13],
  ["ColorLoaderLargeOuterBob" /* ColorLoaderLargeOuterBob */]: colors2.PvsOrange[8],
  ["ColorLoaderLargeInnerBob" /* ColorLoaderLargeInnerBob */]: colors2.PvsOrange[5],
  ["ColorLoaderMediumTopBob" /* ColorLoaderMediumTopBob */]: colors2.PvsOrange[8],
  ["ColorLoaderMediumBackgroundBob" /* ColorLoaderMediumBackgroundBob */]: colors2.Grey[3],
  ["ColorButtonLoaderPrimary" /* ColorButtonLoaderPrimary */]: colors2.PvsOrange[4],
  ["ColorButtonLoaderPrimaryBackground" /* ColorButtonLoaderPrimaryBackground */]: colors2.PvsOrange[7],
  ["ColorButtonLoaderSecondary" /* ColorButtonLoaderSecondary */]: colors2.Grey[8],
  ["ColorButtonLoaderSecondaryBackground" /* ColorButtonLoaderSecondaryBackground */]: colors2.Grey[3],
  ["ColorEnrollmentLoaderOuterSpinner" /* ColorEnrollmentLoaderOuterSpinner */]: colors2.PvsOrange[8],
  ["ColorEnrollmentLoaderInnerSpinner" /* ColorEnrollmentLoaderInnerSpinner */]: colors2.Grey[3],
  ["ColorIconBase" /* ColorIconBase */]: colors2.Grey[14],
  ["ColorIconAlt" /* ColorIconAlt */]: colors2.Grey[10],
  ["ColorIconAlt2" /* ColorIconAlt2 */]: colors2.Grey[9],
  ["ColorIconDisabled" /* ColorIconDisabled */]: colors2.Grey[8],
  ["ColorIconError" /* ColorIconError */]: colors2.RedError[5],
  ["ColorIconWarn" /* ColorIconWarn */]: colors2.Grey[15],
  ["ColorIconSuccess" /* ColorIconSuccess */]: colors2.GreenSuccess[5],
  ["ColorIconInfo" /* ColorIconInfo */]: colors2.BlueInfo[4],
  ["ColorIconAccent" /* ColorIconAccent */]: colors2.AccentRaven[6],
  ["ColorIconLink" /* ColorIconLink */]: colors2.PvsOrange[8],
  ["ColorIconLinkHover" /* ColorIconLinkHover */]: colors2.PvsOrange[12],
  ["ColorIconInvert" /* ColorIconInvert */]: colors2.Grey[1]
};

// src/palettes/overlay.ts
import { colors as colors3 } from "@playvs-inc/nexus-core";
var OverlayPalette = {
  ["OverlayColorOpWhite1" /* OverlayColorOpWhite1 */]: colors3.OpWhite[1],
  ["OverlayColorOpWhite3" /* OverlayColorOpWhite3 */]: colors3.OpWhite[3],
  ["OverlayColorBackgroundAccent" /* OverlayColorBackgroundAccent */]: colors3.PvsOrange[8],
  ["OverlayColorBackgroundAccentAlt" /* OverlayColorBackgroundAccentAlt */]: colors3.PvsOrange[9],
  ["OverlayColorBackgroundAccentAlt2" /* OverlayColorBackgroundAccentAlt2 */]: colors3.PvsOrange[10],
  ["OverlayColorTextBase" /* OverlayColorTextBase */]: colors3.Grey[1],
  ["OverlayColorTextAlt" /* OverlayColorTextAlt */]: colors3.Grey[7],
  ["OverlayColorTextInvert" /* OverlayColorTextInvert */]: colors3.Grey[14],
  ["OverlayColorTextLink" /* OverlayColorTextLink */]: colors3.PvsOrange[7],
  ["OverlayColorTextLinkHover" /* OverlayColorTextLinkHover */]: colors3.PvsOrange[7],
  ["OverlayColorTextDisabled" /* OverlayColorTextDisabled */]: colors3.Grey[8],
  ["OverlayColorBackgroundAlt3" /* OverlayColorBackgroundAlt3 */]: colors3.OpWhite[13],
  ["OverlayColorBackgroundInfo" /* OverlayColorBackgroundInfo */]: colors3.BlueInfo[4],
  ["OverlayColorBackgroundError" /* OverlayColorBackgroundError */]: colors3.RedError[4],
  ["OverlayColorBackgroundSuccess" /* OverlayColorBackgroundSuccess */]: colors3.GreenSuccess[3],
  ["OverlayColorBackgroundWarn" /* OverlayColorBackgroundWarn */]: colors3.YellowWarn[4],
  ["OverlayColorBackgroundMisc" /* OverlayColorBackgroundMisc */]: colors3.AccentRaven[6],
  ["OverlayColorBackgroundInactive" /* OverlayColorBackgroundInactive */]: colors3.OpWhite[7],
  ["OverlayColorBackgroundBrand" /* OverlayColorBackgroundBrand */]: colors3.PvsOrange[9],
  ["OverlayColorIconBase" /* OverlayColorIconBase */]: colors3.Grey[1],
  ["OverlayColorIconAlt" /* OverlayColorIconAlt */]: colors3.Grey[4],
  ["OverlayColorIconAlt2" /* OverlayColorIconAlt2 */]: colors3.Grey[7],
  ["OverlayColorIconDisabled" /* OverlayColorIconDisabled */]: colors3.Grey[9],
  ["OverlayColorIconError" /* OverlayColorIconError */]: colors3.RedError[4],
  ["OverlayColorIconWarn" /* OverlayColorIconWarn */]: colors3.YellowWarn[4],
  ["OverlayColorIconSuccess" /* OverlayColorIconSuccess */]: colors3.GreenSuccess[3],
  ["OverlayColorIconInfo" /* OverlayColorIconInfo */]: colors3.BlueInfo[3],
  ["ColorIconAccent" /* OverlayColorIconAccent */]: colors3.AccentRaven[4],
  ["OverlayColorIconLink" /* OverlayColorIconLink */]: colors3.PvsOrange[8],
  ["OverlayColorIconLinkHover" /* OverlayColorIconLinkHover */]: colors3.PvsOrange[7],
  ["OverlayColorIconInvert" /* OverlayColorIconInvert */]: colors3.Grey[14],
  ["OverlayBorderDark" /* OverlayBorderDark */]: colors3.OpWhite[3],
  ["OverlayBorderMedium" /* OverlayBorderMedium */]: colors3.OpWhite[10],
  ["OverlayBorderLight" /* OverlayBorderLight */]: colors3.OpWhite[13],
  ["OverlayColorOpBlack3" /* OverlayColorOpBlack3 */]: colors3.OpBlack[3]
};

// src/palettes/gradient.ts
import { colors as colors4 } from "@playvs-inc/nexus-core";
var GradientPalette = {
  ["ColorPlayVsGradientExploreStart" /* ColorPlayVsGradientExploreStart */]: colors4.Gwen[5],
  ["ColorPlayVsGradientExploreEnd" /* ColorPlayVsGradientExploreEnd */]: colors4.Gwen[5],
  ["ColorPlayVsGradientMySchoolStart" /* ColorPlayVsGradientMySchoolStart */]: colors4.Grey[13],
  ["ColorPlayVsGradientMySchoolEnd" /* ColorPlayVsGradientMySchoolEnd */]: colors4.Grey[13],
  ["ColorPlayVsGradientManageStart" /* ColorPlayVsGradientManageStart */]: colors4.Sombra[5],
  ["ColorPlayVsGradientManageEnd" /* ColorPlayVsGradientManageEnd */]: colors4.Sombra[5],
  ["ColorPlayVsGradientScheduleStart" /* ColorPlayVsGradientScheduleStart */]: colors4.Phara[6],
  ["ColorPlayVsGradientScheduleEnd" /* ColorPlayVsGradientScheduleEnd */]: colors4.Phara[6]
};

// src/palettes/esports/fifa.ts
import { colors as colors5 } from "@playvs-inc/nexus-core";
var FifaPalette = {
  ["ColorEsportAccentFifa1" /* ColorEsportAccentFifa1 */]: colors5.Fifa[1],
  ["ColorEsportAccentFifa2" /* ColorEsportAccentFifa2 */]: colors5.Fifa[2],
  ["ColorEsportAccentFifa3" /* ColorEsportAccentFifa3 */]: colors5.Fifa[3],
  ["ColorEsportAccentFifaBase" /* ColorEsportAccentFifaBase */]: colors5.Fifa[4],
  ["ColorEsportAccentFifa4" /* ColorEsportAccentFifa4 */]: colors5.Fifa[4],
  ["ColorEsportAccentFifa5" /* ColorEsportAccentFifa5 */]: colors5.Fifa[5],
  ["ColorEsportAccentFifa6" /* ColorEsportAccentFifa6 */]: colors5.Fifa[6],
  ["ColorEsportAccentFifa7" /* ColorEsportAccentFifa7 */]: colors5.Fifa[7],
  ["ColorEsportAccentFifa8" /* ColorEsportAccentFifa8 */]: colors5.Fifa[8],
  ["ColorEsportGradientFifaStart" /* ColorEsportGradientFifaStart */]: colors5.Fifa[7],
  ["ColorEsportGradientFifaEnd" /* ColorEsportGradientFifaEnd */]: colors5.Fifa[8]
};

// src/palettes/esports/fortnite.ts
import { colors as colors6 } from "@playvs-inc/nexus-core";
var FortnitePalette = {
  ["ColorEsportAccentFnBase" /* ColorEsportAccentFnBase */]: colors6.Fortnite[4],
  ["ColorEsportAccentFn1" /* ColorEsportAccentFn1 */]: colors6.Fortnite[1],
  ["ColorEsportAccentFn2" /* ColorEsportAccentFn2 */]: colors6.Fortnite[2],
  ["ColorEsportAccentFn3" /* ColorEsportAccentFn3 */]: colors6.Fortnite[3],
  ["ColorEsportAccentFn4" /* ColorEsportAccentFn4 */]: colors6.Fortnite[4],
  ["ColorEsportAccentFn5" /* ColorEsportAccentFn5 */]: colors6.Fortnite[5],
  ["ColorEsportAccentFn6" /* ColorEsportAccentFn6 */]: colors6.Fortnite[6],
  ["ColorEsportAccentFn7" /* ColorEsportAccentFn7 */]: colors6.Fortnite[7],
  ["ColorEsportAccentFn8" /* ColorEsportAccentFn8 */]: colors6.Fortnite[8],
  ["ColorEsportGradientFnStart" /* ColorEsportGradientFnStart */]: colors6.Fortnite[7],
  ["ColorEsportGradientFnEnd" /* ColorEsportGradientFnEnd */]: colors6.Fortnite[8]
};

// src/palettes/esports/hearthstone.ts
import { colors as colors7 } from "@playvs-inc/nexus-core";
var HearthstonePalette = {
  ["ColorEsportAccentHSBase" /* ColorEsportAccentHSBase */]: colors7.Hs[5],
  ["ColorEsportAccentHS1" /* ColorEsportAccentHS1 */]: colors7.Hs[1],
  ["ColorEsportAccentHS2" /* ColorEsportAccentHS2 */]: colors7.Hs[2],
  ["ColorEsportAccentHS3" /* ColorEsportAccentHS3 */]: colors7.Hs[3],
  ["ColorEsportAccentHS4" /* ColorEsportAccentHS4 */]: colors7.Hs[4],
  ["ColorEsportAccentHS5" /* ColorEsportAccentHS5 */]: colors7.Hs[5],
  ["ColorEsportAccentHS6" /* ColorEsportAccentHS6 */]: colors7.Hs[6],
  ["ColorEsportAccentHS7" /* ColorEsportAccentHS7 */]: colors7.Hs[7],
  ["ColorEsportAccentHS8" /* ColorEsportAccentHS8 */]: colors7.Hs[8],
  ["ColorEsportGradientHSStart" /* ColorEsportGradientHSStart */]: colors7.Hs[7],
  ["ColorEsportGradientHSEnd" /* ColorEsportGradientHSEnd */]: colors7.Hs[8]
};

// src/palettes/esports/leagueOfLegends.ts
import { colors as colors8 } from "@playvs-inc/nexus-core";
var LeagueOfLegendsPalette = {
  ["ColorEsportAccentLoLBase" /* ColorEsportAccentLoLBase */]: colors8.Lol[6],
  ["ColorEsportAccentLoL1" /* ColorEsportAccentLoL1 */]: colors8.Lol[1],
  ["ColorEsportAccentLoL2" /* ColorEsportAccentLoL2 */]: colors8.Lol[2],
  ["ColorEsportAccentLoL3" /* ColorEsportAccentLoL3 */]: colors8.Lol[3],
  ["ColorEsportAccentLoL4" /* ColorEsportAccentLoL4 */]: colors8.Lol[4],
  ["ColorEsportAccentLoL5" /* ColorEsportAccentLoL5 */]: colors8.Lol[5],
  ["ColorEsportAccentLoL6" /* ColorEsportAccentLoL6 */]: colors8.Lol[6],
  ["ColorEsportAccentLoL7" /* ColorEsportAccentLoL7 */]: colors8.Lol[7],
  ["ColorEsportAccentLoL8" /* ColorEsportAccentLoL8 */]: colors8.Lol[8],
  ["ColorEsportGradientLoLStart" /* ColorEsportGradientLoLStart */]: colors8.Lol[7],
  ["ColorEsportGradientLoLEnd" /* ColorEsportGradientLoLEnd */]: colors8.Lol[8]
};

// src/palettes/esports/madden.ts
import { colors as colors9 } from "@playvs-inc/nexus-core";
var MaddenPalette = {
  ["ColorEsportAccentMaddenBase" /* ColorEsportAccentMaddenBase */]: colors9.Madden[4],
  ["ColorEsportAccentMadden1" /* ColorEsportAccentMadden1 */]: colors9.Madden[1],
  ["ColorEsportAccentMadden2" /* ColorEsportAccentMadden2 */]: colors9.Madden[2],
  ["ColorEsportAccentMadden3" /* ColorEsportAccentMadden3 */]: colors9.Madden[3],
  ["ColorEsportAccentMadden4" /* ColorEsportAccentMadden4 */]: colors9.Madden[4],
  ["ColorEsportAccentMadden5" /* ColorEsportAccentMadden5 */]: colors9.Madden[5],
  ["ColorEsportAccentMadden6" /* ColorEsportAccentMadden6 */]: colors9.Madden[6],
  ["ColorEsportAccentMadden7" /* ColorEsportAccentMadden7 */]: colors9.Madden[7],
  ["ColorEsportAccentMadden8" /* ColorEsportAccentMadden8 */]: colors9.Madden[8],
  ["ColorEsportGradientMaddenStart" /* ColorEsportGradientMaddenStart */]: colors9.Madden[7],
  ["ColorEsportGradientMaddenEnd" /* ColorEsportGradientMaddenEnd */]: colors9.Madden[8]
};

// src/palettes/esports/marioKart.ts
import { colors as colors10 } from "@playvs-inc/nexus-core";
var MarioKartPalette = {
  ["ColorEsportAccentMkBase" /* ColorEsportAccentMkBase */]: colors10.Mariokart[4],
  ["ColorEsportAccentMk1" /* ColorEsportAccentMk1 */]: colors10.Mariokart[1],
  ["ColorEsportAccentMk2" /* ColorEsportAccentMk2 */]: colors10.Mariokart[2],
  ["ColorEsportAccentMk3" /* ColorEsportAccentMk3 */]: colors10.Mariokart[3],
  ["ColorEsportAccentMk4" /* ColorEsportAccentMk4 */]: colors10.Mariokart[4],
  ["ColorEsportAccentMk5" /* ColorEsportAccentMk5 */]: colors10.Mariokart[5],
  ["ColorEsportAccentMk6" /* ColorEsportAccentMk6 */]: colors10.Mariokart[6],
  ["ColorEsportAccentMk7" /* ColorEsportAccentMk7 */]: colors10.Mariokart[7],
  ["ColorEsportAccentMk8" /* ColorEsportAccentMk8 */]: colors10.Mariokart[8],
  ["ColorEsportGradientMkStart" /* ColorEsportGradientMkStart */]: colors10.Nintendo,
  ["ColorEsportGradientMkEnd" /* ColorEsportGradientMkEnd */]: colors10.Nintendo
};

// src/palettes/esports/nba2k.ts
import { colors as colors11 } from "@playvs-inc/nexus-core";
var Nba2kPalette = {
  ["ColorEsportAccentNBABase" /* ColorEsportAccentNBABase */]: colors11.Nba2k[7],
  ["ColorEsportAccentNBA1" /* ColorEsportAccentNBA1 */]: colors11.Nba2k[1],
  ["ColorEsportAccentNBA2" /* ColorEsportAccentNBA2 */]: colors11.Nba2k[2],
  ["ColorEsportAccentNBA3" /* ColorEsportAccentNBA3 */]: colors11.Nba2k[3],
  ["ColorEsportAccentNBA4" /* ColorEsportAccentNBA4 */]: colors11.Nba2k[4],
  ["ColorEsportAccentNBA5" /* ColorEsportAccentNBA5 */]: colors11.Nba2k[5],
  ["ColorEsportAccentNBA6" /* ColorEsportAccentNBA6 */]: colors11.Nba2k[6],
  ["ColorEsportAccentNBA7" /* ColorEsportAccentNBA7 */]: colors11.Nba2k[7],
  ["ColorEsportAccentNBA8" /* ColorEsportAccentNBA8 */]: colors11.Nba2k[8],
  ["ColorEsportGradientNBAStart" /* ColorEsportGradientNBAStart */]: colors11.Nba2k[7],
  ["ColorEsportGradientNBAEnd" /* ColorEsportGradientNBAEnd */]: colors11.Nba2k[8]
};

// src/palettes/esports/overwatch.ts
import { colors as colors12 } from "@playvs-inc/nexus-core";
var OverwatchPalette = {
  ["ColorEsportAccentOWBase" /* ColorEsportAccentOWBase */]: colors12.Ow[4],
  ["ColorEsportAccentOW1" /* ColorEsportAccentOW1 */]: colors12.Ow[1],
  ["ColorEsportAccentOW2" /* ColorEsportAccentOW2 */]: colors12.Ow[2],
  ["ColorEsportAccentOW3" /* ColorEsportAccentOW3 */]: colors12.Ow[3],
  ["ColorEsportAccentOW4" /* ColorEsportAccentOW4 */]: colors12.Ow[4],
  ["ColorEsportAccentOW5" /* ColorEsportAccentOW5 */]: colors12.Ow[5],
  ["ColorEsportAccentOW6" /* ColorEsportAccentOW6 */]: colors12.Ow[6],
  ["ColorEsportAccentOW7" /* ColorEsportAccentOW7 */]: colors12.Ow[7],
  ["ColorEsportAccentOW8" /* ColorEsportAccentOW8 */]: colors12.Ow[8],
  ["ColorEsportGradientOWStart" /* ColorEsportGradientOWStart */]: colors12.Ow[7],
  ["ColorEsportGradientOWEnd" /* ColorEsportGradientOWEnd */]: colors12.Ow[8]
};

// src/palettes/esports/rocketLeague.ts
import { colors as colors13 } from "@playvs-inc/nexus-core";
var RocketLeaguePalette = {
  ["ColorEsportAccentRLBase" /* ColorEsportAccentRLBase */]: colors13.Rl[6],
  ["ColorEsportAccentRL1" /* ColorEsportAccentRL1 */]: colors13.Rl[1],
  ["ColorEsportAccentRL2" /* ColorEsportAccentRL2 */]: colors13.Rl[2],
  ["ColorEsportAccentRL3" /* ColorEsportAccentRL3 */]: colors13.Rl[3],
  ["ColorEsportAccentRL4" /* ColorEsportAccentRL4 */]: colors13.Rl[4],
  ["ColorEsportAccentRL5" /* ColorEsportAccentRL5 */]: colors13.Rl[5],
  ["ColorEsportAccentRL6" /* ColorEsportAccentRL6 */]: colors13.Rl[6],
  ["ColorEsportAccentRL7" /* ColorEsportAccentRL7 */]: colors13.Rl[7],
  ["ColorEsportAccentRL8" /* ColorEsportAccentRL8 */]: colors13.Rl[8],
  ["ColorEsportGradientRLStart" /* ColorEsportGradientRLStart */]: colors13.Rl[7],
  ["ColorEsportGradientRLEnd" /* ColorEsportGradientRLEnd */]: colors13.Rl[8]
};

// src/palettes/esports/smashBros.ts
import { colors as colors14 } from "@playvs-inc/nexus-core";
var SmashBrosPalette = {
  ["ColorEsportAccentSUBase" /* ColorEsportAccentSUBase */]: colors14.Smash[4],
  ["ColorEsportAccentSU1" /* ColorEsportAccentSU1 */]: colors14.Smash[1],
  ["ColorEsportAccentSU2" /* ColorEsportAccentSU2 */]: colors14.Smash[2],
  ["ColorEsportAccentSU3" /* ColorEsportAccentSU3 */]: colors14.Smash[3],
  ["ColorEsportAccentSU4" /* ColorEsportAccentSU4 */]: colors14.Smash[4],
  ["ColorEsportAccentSU5" /* ColorEsportAccentSU5 */]: colors14.Smash[5],
  ["ColorEsportAccentSU6" /* ColorEsportAccentSU6 */]: colors14.Smash[6],
  ["ColorEsportAccentSU7" /* ColorEsportAccentSU7 */]: colors14.Smash[7],
  ["ColorEsportAccentSU8" /* ColorEsportAccentSU8 */]: colors14.Smash[8],
  ["ColorEsportGradientSUStart" /* ColorEsportGradientSUStart */]: colors14.Nintendo,
  ["ColorEsportGradientSUEnd" /* ColorEsportGradientSUEnd */]: colors14.Nintendo
};

// src/palettes/esports/smite.ts
import { colors as colors15 } from "@playvs-inc/nexus-core";
var SmitePalette = {
  ["ColorEsportAccentSmite1" /* ColorEsportAccentSmite1 */]: colors15.Smite[1],
  ["ColorEsportAccentSmite2" /* ColorEsportAccentSmite2 */]: colors15.Smite[2],
  ["ColorEsportAccentSmite3" /* ColorEsportAccentSmite3 */]: colors15.Smite[3],
  ["ColorEsportAccentSmiteBase" /* ColorEsportAccentSmiteBase */]: colors15.Smite[4],
  ["ColorEsportAccentSmite4" /* ColorEsportAccentSmite4 */]: colors15.Smite[4],
  ["ColorEsportAccentSmite5" /* ColorEsportAccentSmite5 */]: colors15.Smite[5],
  ["ColorEsportAccentSmite6" /* ColorEsportAccentSmite6 */]: colors15.Smite[6],
  ["ColorEsportAccentSmite7" /* ColorEsportAccentSmite7 */]: colors15.Smite[7],
  ["ColorEsportAccentSmite8" /* ColorEsportAccentSmite8 */]: colors15.Smite[8],
  ["ColorEsportGradientSmiteStart" /* ColorEsportGradientSmiteStart */]: colors15.Smite[7],
  ["ColorEsportGradientSmiteEnd" /* ColorEsportGradientSmiteEnd */]: colors15.Smite[8]
};

// src/palettes/esports/splatoon.ts
import { colors as colors16 } from "@playvs-inc/nexus-core";
var SplatoonPalette = {
  ["ColorEsportAccentSplatoonBase" /* ColorEsportAccentSplatoonBase */]: colors16.Splatoon[4],
  ["ColorEsportAccentSplatoon1" /* ColorEsportAccentSplatoon1 */]: colors16.Splatoon[1],
  ["ColorEsportAccentSplatoon2" /* ColorEsportAccentSplatoon2 */]: colors16.Splatoon[2],
  ["ColorEsportAccentSplatoon3" /* ColorEsportAccentSplatoon3 */]: colors16.Splatoon[3],
  ["ColorEsportAccentSplatoon4" /* ColorEsportAccentSplatoon4 */]: colors16.Splatoon[4],
  ["ColorEsportAccentSplatoon5" /* ColorEsportAccentSplatoon5 */]: colors16.Splatoon[5],
  ["ColorEsportAccentSplatoon6" /* ColorEsportAccentSplatoon6 */]: colors16.Splatoon[6],
  ["ColorEsportAccentSplatoon7" /* ColorEsportAccentSplatoon7 */]: colors16.Splatoon[7],
  ["ColorEsportAccentSplatoon8" /* ColorEsportAccentSplatoon8 */]: colors16.Splatoon[8],
  ["ColorEsportGradientSplatoonStart" /* ColorEsportGradientSplatoonStart */]: colors16.Nintendo,
  ["ColorEsportGradientSplatoonEnd" /* ColorEsportGradientSplatoonEnd */]: colors16.Nintendo
};

// src/palettes/esports/valorant.ts
import { colors as colors17 } from "@playvs-inc/nexus-core";
var ValorantPalette = {
  ["ColorEsportAccentVlrBase" /* ColorEsportAccentVlrBase */]: colors17.Vlr[7],
  ["ColorEsportAccentVlr1" /* ColorEsportAccentVlr1 */]: colors17.Vlr[1],
  ["ColorEsportAccentVlr2" /* ColorEsportAccentVlr2 */]: colors17.Vlr[2],
  ["ColorEsportAccentVlr3" /* ColorEsportAccentVlr3 */]: colors17.Vlr[3],
  ["ColorEsportAccentVlr4" /* ColorEsportAccentVlr4 */]: colors17.Vlr[4],
  ["ColorEsportAccentVlr5" /* ColorEsportAccentVlr5 */]: colors17.Vlr[5],
  ["ColorEsportAccentVlr6" /* ColorEsportAccentVlr6 */]: colors17.Vlr[6],
  ["ColorEsportAccentVlr7" /* ColorEsportAccentVlr7 */]: colors17.Vlr[7],
  ["ColorEsportAccentVlr8" /* ColorEsportAccentVlr8 */]: colors17.Vlr[8],
  ["ColorEsportGradientVlrStart" /* ColorEsportGradientVlrStart */]: colors17.Vlr[7],
  ["ColorEsportGradientVlrEnd" /* ColorEsportGradientVlrEnd */]: colors17.Vlr[8]
};

// src/palettes/esports/chess.ts
import { colors as colors18 } from "@playvs-inc/nexus-core";
var ChessPalette = {
  ["ColorEsportAccentChessBase" /* ColorEsportAccentChessBase */]: colors18.Chess[5],
  ["ColorEsportAccentChess1" /* ColorEsportAccentChess1 */]: colors18.Chess[1],
  ["ColorEsportAccentChess2" /* ColorEsportAccentChess2 */]: colors18.Chess[2],
  ["ColorEsportAccentChess3" /* ColorEsportAccentChess3 */]: colors18.Chess[3],
  ["ColorEsportAccentChess4" /* ColorEsportAccentChess4 */]: colors18.Chess[4],
  ["ColorEsportAccentChess5" /* ColorEsportAccentChess5 */]: colors18.Chess[5],
  ["ColorEsportAccentChess6" /* ColorEsportAccentChess6 */]: colors18.Chess[6],
  ["ColorEsportAccentChess7" /* ColorEsportAccentChess7 */]: colors18.Chess[7],
  ["ColorEsportAccentChess8" /* ColorEsportAccentChess8 */]: colors18.Chess[8],
  ["ColorEsportGradientChessStart" /* ColorEsportGradientChessStart */]: colors18.Chess[7],
  ["ColorEsportGradientChessEnd" /* ColorEsportGradientChessEnd */]: colors18.Chess[8]
};

// src/palettes/esports/fc.ts
import { colors as colors19 } from "@playvs-inc/nexus-core";
var FCPalette = {
  ["ColorEsportAccentFCBase" /* ColorEsportAccentFCBase */]: colors19.FC[4],
  ["ColorEsportAccentFC1" /* ColorEsportAccentFC1 */]: colors19.FC[1],
  ["ColorEsportAccentFC2" /* ColorEsportAccentFC2 */]: colors19.FC[2],
  ["ColorEsportAccentFC3" /* ColorEsportAccentFC3 */]: colors19.FC[3],
  ["ColorEsportAccentFC4" /* ColorEsportAccentFC4 */]: colors19.FC[4],
  ["ColorEsportAccentFC5" /* ColorEsportAccentFC5 */]: colors19.FC[5],
  ["ColorEsportAccentFC6" /* ColorEsportAccentFC6 */]: colors19.FC[6],
  ["ColorEsportAccentFC7" /* ColorEsportAccentFC7 */]: colors19.FC[7],
  ["ColorEsportAccentFC8" /* ColorEsportAccentFC8 */]: colors19.FC[8],
  ["ColorEsportGradientFCStart" /* ColorEsportGradientFCStart */]: colors19.FC[7],
  ["ColorEsportGradientFCEnd" /* ColorEsportGradientFCEnd */]: colors19.FC[8]
};

// src/palettes/esports/streetFighter6.ts
import { colors as colors20 } from "@playvs-inc/nexus-core";
var SF6Palette = {
  ["ColorEsportAccentSF61" /* ColorEsportAccentSF61 */]: colors20.SF6[1],
  ["ColorEsportAccentSF62" /* ColorEsportAccentSF62 */]: colors20.SF6[2],
  ["ColorEsportAccentSF63" /* ColorEsportAccentSF63 */]: colors20.SF6[3],
  ["ColorEsportAccentSF6Base" /* ColorEsportAccentSF6Base */]: colors20.SF6[4],
  ["ColorEsportAccentSF64" /* ColorEsportAccentSF64 */]: colors20.SF6[4],
  ["ColorEsportAccentSF65" /* ColorEsportAccentSF65 */]: colors20.SF6[5],
  ["ColorEsportAccentSF66" /* ColorEsportAccentSF66 */]: colors20.SF6[6],
  ["ColorEsportAccentSF67" /* ColorEsportAccentSF67 */]: colors20.SF6[7],
  ["ColorEsportAccentSF68" /* ColorEsportAccentSF68 */]: colors20.SF6[8],
  ["ColorEsportGradientSF6Start" /* ColorEsportGradientSF6Start */]: colors20.SF6[7],
  ["ColorEsportGradientSF6End" /* ColorEsportGradientSF6End */]: colors20.SF6[8]
};

// src/palettes/esports/formula1.ts
import { colors as colors21 } from "@playvs-inc/nexus-core";
var F1Palette = {
  ["ColorEsportAccentF11" /* ColorEsportAccentF11 */]: colors21.F1[1],
  ["ColorEsportAccentF12" /* ColorEsportAccentF12 */]: colors21.F1[2],
  ["ColorEsportAccentF13" /* ColorEsportAccentF13 */]: colors21.F1[3],
  ["ColorEsportAccentF1Base" /* ColorEsportAccentF1Base */]: colors21.F1[4],
  ["ColorEsportAccentF14" /* ColorEsportAccentF14 */]: colors21.F1[4],
  ["ColorEsportAccentF15" /* ColorEsportAccentF15 */]: colors21.F1[5],
  ["ColorEsportAccentF16" /* ColorEsportAccentF16 */]: colors21.F1[6],
  ["ColorEsportAccentF17" /* ColorEsportAccentF17 */]: colors21.F1[7],
  ["ColorEsportAccentF18" /* ColorEsportAccentF18 */]: colors21.F1[8],
  ["ColorEsportGradientF1Start" /* ColorEsportGradientF1Start */]: colors21.F1[7],
  ["ColorEsportGradientF1End" /* ColorEsportGradientF1End */]: colors21.F1[8]
};

// src/palettes/esports/minecraft.ts
import { colors as colors22 } from "@playvs-inc/nexus-core";
var MCPalette = {
  ["ColorEsportAccentMCBase" /* ColorEsportAccentMCBase */]: colors22.MC[6],
  ["ColorEsportAccentMC1" /* ColorEsportAccentMC1 */]: colors22.MC[1],
  ["ColorEsportAccentMC2" /* ColorEsportAccentMC2 */]: colors22.MC[2],
  ["ColorEsportAccentMC3" /* ColorEsportAccentMC3 */]: colors22.MC[3],
  ["ColorEsportAccentMC4" /* ColorEsportAccentMC4 */]: colors22.MC[4],
  ["ColorEsportAccentMC5" /* ColorEsportAccentMC5 */]: colors22.MC[5],
  ["ColorEsportAccentMC6" /* ColorEsportAccentMC6 */]: colors22.MC[6],
  ["ColorEsportAccentMC7" /* ColorEsportAccentMC7 */]: colors22.MC[7],
  ["ColorEsportAccentMC8" /* ColorEsportAccentMC8 */]: colors22.MC[8],
  ["ColorEsportGradientMCStart" /* ColorEsportGradientMCStart */]: colors22.MC[7],
  ["ColorEsportGradientMCEnd" /* ColorEsportGradientMCEnd */]: colors22.MC[8]
};

// src/palettes/esports/pokemonUnite.ts
import { colors as colors23 } from "@playvs-inc/nexus-core";
var PUPalette = {
  ["ColorEsportAccentPUBase" /* ColorEsportAccentPUBase */]: colors23.PU[6],
  ["ColorEsportAccentPU1" /* ColorEsportAccentPU1 */]: colors23.PU[1],
  ["ColorEsportAccentPU2" /* ColorEsportAccentPU2 */]: colors23.PU[2],
  ["ColorEsportAccentPU3" /* ColorEsportAccentPU3 */]: colors23.PU[3],
  ["ColorEsportAccentPU4" /* ColorEsportAccentPU4 */]: colors23.PU[4],
  ["ColorEsportAccentPU5" /* ColorEsportAccentPU5 */]: colors23.PU[5],
  ["ColorEsportAccentPU6" /* ColorEsportAccentPU6 */]: colors23.PU[6],
  ["ColorEsportAccentPU7" /* ColorEsportAccentPU7 */]: colors23.PU[7],
  ["ColorEsportAccentPU8" /* ColorEsportAccentPU8 */]: colors23.PU[8],
  ["ColorEsportGradientPUStart" /* ColorEsportGradientPUStart */]: colors23.PU[7],
  ["ColorEsportGradientPUEnd" /* ColorEsportGradientPUEnd */]: colors23.PU[8]
};

// src/palettes/esports/collegeFootball25.ts
import { colors as colors24 } from "@playvs-inc/nexus-core";
var CFB25Palette = {
  ["ColorEsportAccentCFB25Base" /* ColorEsportAccentCFB25Base */]: colors24.CFB25[5],
  ["ColorEsportAccentCFB251" /* ColorEsportAccentCFB251 */]: colors24.CFB25[1],
  ["ColorEsportAccentCFB252" /* ColorEsportAccentCFB252 */]: colors24.CFB25[2],
  ["ColorEsportAccentCFB253" /* ColorEsportAccentCFB253 */]: colors24.CFB25[3],
  ["ColorEsportAccentCFB254" /* ColorEsportAccentCFB254 */]: colors24.CFB25[4],
  ["ColorEsportAccentCFB255" /* ColorEsportAccentCFB255 */]: colors24.CFB25[5],
  ["ColorEsportAccentCFB256" /* ColorEsportAccentCFB256 */]: colors24.CFB25[6],
  ["ColorEsportAccentCFB257" /* ColorEsportAccentCFB257 */]: colors24.CFB25[7],
  ["ColorEsportAccentCFB258" /* ColorEsportAccentCFB258 */]: colors24.CFB25[8],
  ["ColorEsportGradientCFB25Start" /* ColorEsportGradientCFB25Start */]: colors24.CFB25[7],
  ["ColorEsportGradientCFB25End" /* ColorEsportGradientCFB25End */]: colors24.CFB25[8]
};

// src/palettes/esports/aram.ts
import { colors as colors25 } from "@playvs-inc/nexus-core";
var ARAMPalette = {
  ["ColorEsportAccentARAMBase" /* ColorEsportAccentARAMBase */]: colors25.ARAM[5],
  ["ColorEsportAccentARAM1" /* ColorEsportAccentARAM1 */]: colors25.ARAM[1],
  ["ColorEsportAccentARAM2" /* ColorEsportAccentARAM2 */]: colors25.ARAM[2],
  ["ColorEsportAccentARAM3" /* ColorEsportAccentARAM3 */]: colors25.ARAM[3],
  ["ColorEsportAccentARAM4" /* ColorEsportAccentARAM4 */]: colors25.ARAM[4],
  ["ColorEsportAccentARAM5" /* ColorEsportAccentARAM5 */]: colors25.ARAM[5],
  ["ColorEsportAccentARAM6" /* ColorEsportAccentARAM6 */]: colors25.ARAM[6],
  ["ColorEsportAccentARAM7" /* ColorEsportAccentARAM7 */]: colors25.ARAM[7],
  ["ColorEsportAccentARAM8" /* ColorEsportAccentARAM8 */]: colors25.ARAM[8],
  ["ColorEsportGradientARAMStart" /* ColorEsportGradientARAMStart */]: colors25.ARAM[7],
  ["ColorEsportGradientARAMEnd" /* ColorEsportGradientARAMEnd */]: colors25.ARAM[8]
};

// src/palettes/esports.ts
var EsportsPalette = __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, FifaPalette), FortnitePalette), HearthstonePalette), LeagueOfLegendsPalette), MaddenPalette), MarioKartPalette), Nba2kPalette), OverwatchPalette), RocketLeaguePalette), SmashBrosPalette), SmitePalette), SplatoonPalette), ValorantPalette), ChessPalette), FCPalette), SF6Palette), F1Palette), MCPalette), PUPalette), ARAMPalette), CFB25Palette);

// src/mui/themeModeEnum.ts
var ThemeModeEnum = /* @__PURE__ */ ((ThemeModeEnum2) => {
  ThemeModeEnum2["Dark"] = "dark";
  ThemeModeEnum2["Light"] = "light";
  ThemeModeEnum2["Overlay"] = "overlay";
  return ThemeModeEnum2;
})(ThemeModeEnum || {});

// src/typography/base.ts
import { fontType } from "@playvs-inc/nexus-core";
var baseTypography = {
  fontFamily: fontType.fontFamily,
  display: {
    fontSize: "2.566rem",
    fontWeight: 700,
    letterSpacing: "-0.02rem",
    lineHeight: "108%"
  },
  display2: {
    fontSize: "2.281rem",
    fontWeight: 700,
    letterSpacing: "-0.02rem",
    lineHeight: "122%"
  },
  display3: {
    fontSize: "2.027rem",
    fontWeight: 700,
    letterSpacing: "-0.02rem",
    lineHeight: "108%"
  },
  h1: {
    fontSize: "1.802rem",
    fontWeight: 700,
    letterSpacing: "-0.01rem",
    lineHeight: "112%"
  },
  h2: {
    fontSize: "1.602rem",
    fontWeight: 700,
    letterSpacing: "-0.01rem",
    lineHeight: "133%"
  },
  h3: {
    fontSize: "1.424rem",
    fontWeight: 700,
    letterSpacing: "-0.01rem",
    lineHeight: "112%"
  },
  h4: {
    fontSize: "1.266rem",
    fontWeight: 700,
    letterSpacing: "-0.01rem",
    lineHeight: "133%"
  },
  subtitle1: {
    fontSize: "1.125rem",
    fontWeight: 400,
    letterSpacing: 0,
    lineHeight: "130%"
  },
  subtitle2: {
    fontSize: "0.889rem",
    fontWeight: 400,
    letterSpacing: "0.08rem",
    lineHeight: "138%"
  },
  subtitle3: {
    fontSize: "0.885rem",
    fontWeight: 500,
    letterSpacing: "0.08rem",
    lineHeight: "138%",
    textTransform: "uppercase"
  },
  body1: {
    fontSize: "1rem",
    fontWeight: 400,
    letterSpacing: 0,
    lineHeight: "133%",
    fontFamily: fontType.fontFamily
  },
  body2: {
    fontSize: "1rem",
    fontWeight: 600,
    letterSpacing: 0,
    lineHeight: "133%"
  },
  body3: {
    fontSize: "0.889rem",
    fontWeight: 400,
    letterSpacing: 0,
    lineHeight: "138%"
  },
  body4: {
    fontSize: "0.79rem",
    fontWeight: 400,
    letterSpacing: 0,
    lineHeight: "138%"
  },
  body5: {
    fontSize: "0.702rem",
    fontWeight: 400,
    letterSpacing: 0,
    lineHeight: "160%"
  },
  overline: {
    fontSize: "0.702rem",
    fontWeight: 600,
    letterSpacing: "0.12rem",
    lineHeight: "114%",
    textTransform: "uppercase"
  },
  button: {
    fontSize: "0.889rem",
    fontWeight: 600,
    letterSpacing: "0.12rem",
    lineHeight: "125%"
  }
};

// src/mui/typography/base.ts
var baseThemeTypography = (theme) => ({
  fontFamily: baseTypography.fontFamily,
  display: __spreadProps(__spreadValues({}, baseTypography.display), {
    [theme.breakpoints.down("md")]: {
      fontSize: "2.566rem",
      fontWeight: 700,
      letterSpacing: "-0.02rem",
      lineHeight: "108%"
    }
  }),
  display2: __spreadProps(__spreadValues({}, baseTypography.display2), {
    [theme.breakpoints.down("md")]: {
      fontSize: "2.281rem",
      fontWeight: 700,
      letterSpacing: "-0.02rem",
      lineHeight: "122%"
    }
  }),
  display3: __spreadProps(__spreadValues({}, baseTypography.display3), {
    [theme.breakpoints.down("md")]: {
      fontSize: "2.027rem",
      fontWeight: 700,
      letterSpacing: "-0.02rem",
      lineHeight: "108%"
    }
  }),
  h1: __spreadProps(__spreadValues({}, baseTypography.h1), {
    [theme.breakpoints.down("md")]: {
      fontSize: "1.802rem",
      fontWeight: 700,
      letterSpacing: "-0.01rem",
      lineHeight: "112%"
    }
  }),
  h2: __spreadProps(__spreadValues({}, baseTypography.h2), {
    [theme.breakpoints.down("md")]: {
      fontSize: "1.602rem",
      fontWeight: 700,
      letterSpacing: "-0.01rem",
      lineHeight: "133%"
    }
  }),
  h3: __spreadProps(__spreadValues({}, baseTypography.h3), {
    [theme.breakpoints.down("md")]: {
      fontSize: "1.424rem",
      fontWeight: 700,
      letterSpacing: "-0.01rem",
      lineHeight: "112%"
    }
  }),
  h4: __spreadProps(__spreadValues({}, baseTypography.h4), {
    [theme.breakpoints.down("md")]: {
      fontSize: "1.266rem",
      fontWeight: 700,
      letterSpacing: "-0.01rem",
      lineHeight: "133%"
    }
  }),
  subtitle1: __spreadProps(__spreadValues({}, baseTypography.subtitle1), {
    [theme.breakpoints.down("md")]: {
      fontSize: "1.125rem",
      fontWeight: 600,
      letterSpacing: 0,
      lineHeight: "130%"
    }
  }),
  subtitle2: __spreadProps(__spreadValues({}, baseTypography.subtitle2), {
    [theme.breakpoints.down("md")]: {
      fontSize: "0.889rem",
      fontWeight: 400,
      letterSpacing: "0.08rem",
      lineHeight: "138%"
    }
  }),
  subtitle3: __spreadProps(__spreadValues({}, baseTypography.subtitle3), {
    [theme.breakpoints.down("md")]: {
      fontSize: "0.889rem",
      fontWeight: 500,
      letterSpacing: "0.08rem",
      lineHeight: "138%"
    }
  }),
  body1: __spreadProps(__spreadValues({}, baseTypography.body1), {
    [theme.breakpoints.down("md")]: {
      fontSize: "1rem",
      fontWeight: 500,
      letterSpacing: 0,
      lineHeight: "133%"
    }
  }),
  body2: __spreadProps(__spreadValues({}, baseTypography.body2), {
    [theme.breakpoints.down("md")]: {
      fontSize: "1rem",
      fontWeight: 600,
      letterSpacing: 0,
      lineHeight: "133%"
    }
  }),
  body3: __spreadProps(__spreadValues({}, baseTypography.body3), {
    [theme.breakpoints.down("md")]: {
      fontSize: "0.889rem",
      fontWeight: 400,
      letterSpacing: 0,
      lineHeight: "138%"
    }
  }),
  body4: __spreadProps(__spreadValues({}, baseTypography.body4), {
    [theme.breakpoints.down("md")]: {
      fontSize: "0.79rem",
      fontWeight: 500,
      letterSpacing: 0,
      lineHeight: "138%"
    }
  }),
  body5: __spreadProps(__spreadValues({}, baseTypography.body5), {
    [theme.breakpoints.down("md")]: {
      fontSize: "0.702rem",
      fontWeight: 400,
      letterSpacing: 0,
      lineHeight: "160%"
    }
  }),
  overline: __spreadProps(__spreadValues({}, baseTypography.overline), {
    [theme.breakpoints.down("md")]: {
      fontSize: "0.702rem",
      fontWeight: 700,
      letterSpacing: "0.012rem",
      lineHeight: "125%",
      textTransform: "uppercase"
    }
  }),
  button: __spreadProps(__spreadValues({}, baseTypography.button), {
    [theme.breakpoints.down("md")]: {
      fontSize: "0.889rem",
      fontWeight: 700,
      letterSpacing: "0.06rem",
      lineHeight: "114%"
    }
  })
});

// src/mui/PlayVsOverlayTheme.ts
import { colors as colors27 } from "@playvs-inc/nexus-core";
import { createTheme as createTheme2 } from "@material-ui/core";
import { mergeDeepRight } from "ramda";

// src/mui/utils.ts
import { colors as colors26, cornerRadius } from "@playvs-inc/nexus-core";
import createTheme from "@material-ui/core/styles/createTheme";

// src/mui/overrides/base.ts
var baseOverrides = () => ({
  props: {
    MuiButtonBase: {
      disableRipple: true
    },
    MuiCardHeader: {
      titleTypographyProps: {
        variant: "h4"
      }
    }
  }
});

// src/mui/overrides/component.ts
var MuiCssBaseline = (theme) => ({
  body: {
    fontWeight: "bold",
    fontSize: 18,
    [theme.breakpoints.down("md")]: {
      fontSize: 16
    }
  }
});
var getComponentOverrides = (theme) => ({
  MuiCssBaseline: MuiCssBaseline(theme)
});

// src/mui/utils.ts
var mapColorTokensToPalette = (themeTokens) => ({
  primary: {
    main: themeTokens["ColorBackgroundAccent" /* ColorBackgroundAccent */]
  },
  secondary: {
    main: themeTokens["ColorTextBase" /* ColorTextBase */]
  },
  text: {
    primary: themeTokens["ColorTextBase" /* ColorTextBase */],
    secondary: themeTokens["ColorTextAlt" /* ColorTextAlt */],
    disabled: themeTokens["ColorTextDisabled" /* ColorTextDisabled */],
    hint: themeTokens["ColorTextDisabled" /* ColorTextDisabled */]
  },
  background: {
    default: themeTokens["ColorBackgroundBody" /* ColorBackgroundBody */],
    paper: themeTokens["ColorBackgroundBase" /* ColorBackgroundBase */]
  },
  error: {
    main: themeTokens["ColorTextError" /* ColorTextError */]
  },
  warning: {
    main: themeTokens["ColorTextWarn" /* ColorTextWarn */]
  },
  info: {
    main: themeTokens["ColorTextInfo" /* ColorTextInfo */]
  },
  success: {
    main: themeTokens["ColorTextSuccess" /* ColorTextSuccess */]
  },
  action: {
    disabledBackground: themeTokens["ColorBackgroundAlt3" /* ColorBackgroundAlt3 */],
    disabled: themeTokens["ColorTextDisabled" /* ColorTextDisabled */]
  },
  divider: themeTokens["BorderDark" /* BorderDark */],
  loader: {
    large: {
      outerBob: themeTokens["ColorLoaderLargeOuterBob" /* ColorLoaderLargeOuterBob */],
      innerBob: themeTokens["ColorLoaderLargeInnerBob" /* ColorLoaderLargeInnerBob */]
    },
    medium: {
      topBob: themeTokens["ColorLoaderMediumTopBob" /* ColorLoaderMediumTopBob */],
      backgroundBob: themeTokens["ColorLoaderMediumBackgroundBob" /* ColorLoaderMediumBackgroundBob */]
    },
    button: {
      primary: themeTokens["ColorButtonLoaderPrimary" /* ColorButtonLoaderPrimary */],
      primaryBackground: themeTokens["ColorButtonLoaderPrimaryBackground" /* ColorButtonLoaderPrimaryBackground */],
      secondary: themeTokens["ColorButtonLoaderSecondary" /* ColorButtonLoaderSecondary */],
      secondaryBackground: themeTokens["ColorButtonLoaderSecondaryBackground" /* ColorButtonLoaderSecondaryBackground */]
    },
    enrollment: {
      outerSpinner: themeTokens["ColorEnrollmentLoaderOuterSpinner" /* ColorEnrollmentLoaderOuterSpinner */],
      innerSpinner: themeTokens["ColorEnrollmentLoaderInnerSpinner" /* ColorEnrollmentLoaderInnerSpinner */]
    }
  }
});
function composeTheme(mixins, themeTokens, name = "PlayVs Theme", type = "light" /* Light */) {
  const paletteOverrides = {
    primary: {
      main: themeTokens["ColorBackgroundAccent" /* ColorBackgroundAccent */]
    },
    error: {
      main: colors26.RedError[5]
    }
  };
  const theme = createTheme(__spreadValues({
    palette: __spreadValues(__spreadValues(__spreadValues({
      type
    }, mapColorTokensToPalette(themeTokens)), themeTokens), paletteOverrides),
    shape: {
      border: {
        button: cornerRadius["border-radius-2"]
      }
    },
    mixins: __spreadProps(__spreadValues({}, mixins), {
      cornerRadius
    })
  }, baseOverrides()));
  theme.overrides = getComponentOverrides(theme);
  theme.typography = __spreadValues(__spreadValues({}, theme.typography), baseThemeTypography(theme));
  Object.assign(theme, { name });
  return theme;
}

// src/mixins/dark.ts
var darkBoxShadow = {
  elevation0: "inset 0px 1px 4px 0px rgba(0, 0, 0, 0.08)",
  elevation1: "0px 2px 16px rgba(0, 0, 0, 0.24), 0px 1px 2px rgba(0, 0, 0, 0.24)",
  elevation2: "0px 1px 2px rgba(0, 0, 0, 0.34), 0px 2px 8px rgba(0, 0, 0, 0.34)",
  elevation3: "0px 1px 4px rgba(0, 0, 0, 0.44), 0px 8px 12px rgba(0, 0, 0, 0.44)",
  elevation4: "0px 2px 8px rgba(0, 0, 0, 0.54), 0px 8px 24px rgba(0, 0, 0, 0.54)"
};
var darkDivider = {
  bottom: "inset 0px -1px 0px rgba(255, 255, 255, 0.15)",
  top: "inset 0px 1px 0px rgba(255, 255, 255, 0.15)",
  left: "inset 1px 0px 0px rgba(255, 255, 255, 0.15)",
  right: "inset -1px 0px 0px rgba(255, 255, 255, 0.15)"
};

// src/mui/PlayVsDarkTheme.ts
var Palette = __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, EsportsPalette), DarkPalette), OverlayPalette), GradientPalette);
var ThemeName = "PlayVs Dark Theme";
var Mixins = {
  boxShadow: darkBoxShadow,
  divider: darkDivider
};
var PlayVsDarkTheme = composeTheme(Mixins, Palette, ThemeName, "dark" /* Dark */);

// src/mui/PlayVsOverlayTheme.ts
var darkThemeJson = JSON.parse(JSON.stringify(PlayVsDarkTheme));
var Mixins2 = {
  boxShadow: darkBoxShadow,
  divider: darkDivider
};
var PlayVsOverlayTheme = createTheme2(mergeDeepRight(darkThemeJson, {
  palette: {
    background: {
      default: colors27.OpBlack[3],
      paper: colors27.OpWhite[1]
    },
    OpacityBlack1: colors27.OpBlack[3],
    OpacityBlack2: colors27.OpBlack[4],
    OpacityBlack3: colors27.OpBlack[6],
    OpacityWhite1: colors27.OpBlack[1],
    OpacityWhite2: colors27.OpBlack[10],
    OpacityWhite3: colors27.OpWhite[13]
  },
  Mixins: Mixins2
}));
Object.assign(PlayVsOverlayTheme, { name: "PlayVs Overlay Theme" });

// src/mixins/light.ts
var lightBoxShadow = {
  elevation0: "inset 0px 1px 4px 0px rgba(0, 0, 0, 0.08)",
  elevation1: "0px 2px 16px rgba(0, 0, 0, 0.04), 0px 1px 2px rgba(0, 0, 0, 0.04)",
  elevation2: "0px 1px 2px rgba(0, 0, 0, 0.08), 0px 2px 8px rgba(0, 0, 0, 0.12)",
  elevation3: "0px 1px 4px rgba(0, 0, 0, 0.04), 0px 8px 12px rgba(0, 0, 0, 0.12)",
  elevation4: "0px 2px 8px rgba(0, 0, 0, 0.24), 0px 8px 24px rgba(0, 0, 0, 0.24)"
};
var lightDivider = {
  bottom: "inset 0px -1px 0px rgba(0, 0, 0, 0.15)",
  top: "inset 0px 1px 0px rgba(0, 0, 0, 0.15)",
  left: "inset 1px 0px 0px rgba(0, 0, 0, 0.15)",
  right: "inset -1px 0px 0px rgba(0, 0, 0, 0.15)"
};

// src/mui/PlayVsTheme.ts
var Palette2 = __spreadValues(__spreadValues(__spreadValues(__spreadValues({}, EsportsPalette), LightPalette), OverlayPalette), GradientPalette);
var ThemeName2 = "PlayVs Theme";
var Mixins3 = {
  boxShadow: lightBoxShadow,
  divider: lightDivider
};
var PlayVsTheme = composeTheme(Mixins3, Palette2, ThemeName2, "light" /* Light */);

// src/mui/theme.d.ts
var theme_d_exports = {};

// src/providers/EsportsProvider.tsx
import React, { createContext, useContext } from "react";
var emptyEsport = {
  name: "",
  slug: "",
  palette: {
    1: "",
    2: "",
    3: "",
    4: "",
    5: "",
    6: "",
    7: "",
    8: "",
    baseColor: "",
    gradientStart: "",
    gradientEnd: ""
  }
};
var defaultValue = {
  "street-fighter": {
    name: "Street Fighter",
    slug: "street-fighter",
    palette: {
      1: "#EFE9FB",
      2: "#CFBEF4",
      3: "#AF93EC",
      4: "#5D25D4",
      5: "#491DA5",
      6: "#2C1264",
      7: "#1D0B41",
      8: "#13082B",
      baseColor: "#491DA5",
      gradientStart: "#5D25D4",
      gradientEnd: "#13082B"
    }
  }
};
var NxEsportsContext = createContext(defaultValue);
function NxEsportsProvider({
  children,
  esports
}) {
  return /* @__PURE__ */ React.createElement(NxEsportsContext.Provider, {
    value: esports
  }, children);
}
function useNxEsportsContext() {
  return useContext(NxEsportsContext);
}
function useEsport(esportSlug) {
  var _a;
  const esports = useNxEsportsContext();
  return (_a = esports[esportSlug]) != null ? _a : emptyEsport;
}
export {
  DarkPalette,
  EsportsPalette,
  EsportsTokens,
  FifaPalette,
  FifaTokens,
  FortnitePalette,
  FortniteTokens,
  GradientPalette,
  GradientTokens,
  HearthStoneTokens,
  HearthstonePalette,
  LeagueOfLegendsPalette,
  LeagueOfLegendsTokens,
  LightPalette,
  ThemeModeEnum as MUIThemeModeEnum,
  theme_d_exports as MUIThemeType,
  MaddenPalette,
  MaddenTokens,
  MarioKartPalette,
  MarioKartTokens,
  Nba2kPalette,
  Nba2kTokens,
  NxEsportsProvider,
  OverlayPalette,
  OverlayTokens,
  OverwatchPalette,
  OverwatchTokens,
  PlayVsDarkTheme,
  PlayVsOverlayTheme,
  PlayVsTheme,
  RocketLeaguePalette,
  RocketLeagueTokens,
  SmashBrosPalette,
  SmashBrosTokens,
  SmitePalette,
  SmiteTokens,
  SplatoonPalette,
  SplatoonTokens,
  ThemeTokens,
  baseThemeTypography,
  baseTypography,
  composeTheme,
  mapColorTokensToPalette,
  useEsport,
  useNxEsportsContext
};
//# sourceMappingURL=index.js.map